
function UnitAnalogEditor() {
    /// <summary>
    /// This object provides js functions for VC.Widget.Unit.AnalogEditor <br/>
    ///TODO: documentation






    /// <br/>
    /// Author: ARF<br />
    /// Date: 14.3.2018<br />
    /// Copyright ©: EUDT GmbH 2018 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 5.4.2018                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.last_hw = 0; //helper variable for canceling the change of the hardware ddl 
    this.ruleVarname = "RULE";
    this.noZstID = 121;
    this.ruleFormVCID = 152;//275  //152
    this.cancelRules = false;
    this.lastFilterString = "-1";
    this.lastView = "addr";
    this.logsPopup = null;
}

UnitAnalogEditor.prototype = new vcTemplate();

UnitAnalogEditor.prototype.init = function () {
    /// <summary>
    /// This function inits the click handler, events and other initial stuff. 
    /// </summary>
    var me = this;


    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        me.toggleWaiting(true, -1);
        //me.showDevIcon("dev");

        me.visual.find(".vc-list.signals .vc-list-header span").tipTip();

      
        me.adoptListHeight();
        me.visual.find(".vc-list.import").height(me.visual.find(".vc-list.signals").height() - 10);


        me.visual.find("#modal-waiting-text").css("top", parseInt(me.visual.find("#signal-table").position().top, 10));
        me.visual.find("#modal-waiting-text").width(parseInt(me.visual.find("#signal-table").width, 10));

        me.parameter.blhid = 0;

        me.visual.find("#div-filter").vcFilter({ callback: function () { me.filter(); } });


        //init the top horizontal menu
        me.visual.find(".select-view").off("click").on("click", function () { me.selectView($(this)); });

        me.visual.find(".vc-list.import #vc-list-selection").height(parseInt(me.visual.find("#signal-table").height() - me.visual.find(".vc-list.import #div-import-unit").height(), 10) - 10);

        me.initCopyMenu();


        //unit dropdown handler
        me.visual.find(".vc-list.import .ddl-import-unit").removeClass("fld").off("change").on("change", function () { me.loadImportList(); });

        //init click handler for top menu - basic filter settings
        me.visual.find("#div-btn-import").off("click").on("click", function () {
            me.toggleImportList($(this), me.visual.find(".vc-list.import").is(":visible") === false, true);
        });

        me.setUnitViewerWidth();


        //click handler for the unit hardwares
        //set the tooltip for the unit hardwares
        me.visual.find('#div-unit-viewer #lstUnit li').tipTip({ defaultPosition: 'bottom' });
        //click handler for the unit hardwares
        me.visual.find(".div-unit-viewer-rules").off("click").on("click", function () { me.selectHardware($(this)); });

        me.visual.find("#div-unit-viewer").off("click", "li").on("click", "li", function () { me.selectHardware($(this)); });

        //unit dropdown handler
        me.visual.find("#div-unit-menu #ddl-unit-dest").off("click").on("click", function () { me.showUnit(true); });





       //validation events
        me.visual.find("#signal-table").off("change", ".ddl").on("change", ".ddl", function (e) { me.validate($(e.target)) });
        me.visual.find("#signal-table").off("change", "input").on("change", "input", function (e) { me.validate($(e.target)) });
        me.visual.find("#signal-table").off("keyup", "input").on("keyup", "input", function (e) { me.validate($(e.target)) });
        me.visual.find("#signal-table").off("change", "textarea").on("change", "textarea", function (e) {  me.validate($(e.target)) });
        me.visual.find("#signal-table").off("keyup", "textarea").on("keyup", "textarea", function (e) {   me.validate($(e.target)) });
        me.visual.find("#signal-table").off("click", ".chb").on("click", ".chb", function (e) { me.isValid($(e.target), true); });

        //me.visual.find("#signal-table").off("click", ".btn-load-rule").on("click", ".btn-load-rule", function(e) {
        //    //var bsaid = $(e.target).parents("li").data("bsaid");

        //    //$(e.target).parents("li").find(".rule").show().html("<div id='div-rule-" + bsaid + "' ></div>");
        //    //var obj = {bsaid: bsaid, w:1000}
        //    me.loadRule($(e.target));
           
        //});

        //click handler for the selection checkbox (when using the signal menu)
        me.visual.find("#signal-table").off("change", ".chb-selection").on("change", ".chb-selection", function() {
            if ($(this).is(":checked")) {
                $(this).parents(".entry").removeClass("minify").addClass("selected");
            } else {
                $(this).parents(".entry").addClass("minify").removeClass("selected");
            }
        });

        me.visual.find("#div-signal-menu #chb-select-all").off("change").on("change", function () {
            if ($(this).is(":checked")) {
                me.visual.find("#signal-table li.found .entry").removeClass("minify selected").addClass("selected");
                    me.visual.find("#signal-table .found .chb-selection").prop("checked", true);
        } else {
                me.visual.find("#signal-table .entry").removeClass("minify selected").addClass("minify");
             me.visual.find("#signal-table .chb-selection").prop("checked", false);
    }
    });


     

        //TODO: make a function
        me.visual.find("#div-paging").off("click", ".btn-paging").on("click", ".btn-paging", function() {

            var obj = $(this);
            me.visual.find("#div-paging .button-toggle").removeClass("button-toggle-active");

            obj.addClass("button-toggle-active");


            if (me.visual.find("#div-btn-save").hasClass("active") || me.visual.find("#div-state").hasClass("error")) {

                //open the dialog
                me.openAskDialog(me.resources.dismissChanges,
                    { at: 'center center-30%', of: window  },
                    function () {
                       
                        me.visual.find("#signal-table").html("").hide();
                        //add the entries
                        _VCMQ.produce(me.visual, me.vcgid, 'ADD_ENTRIES', me.entries);                      
                    });

            } else {
              
                me.visual.find("#signal-table").html("").hide();
                //add the entries
                _VCMQ.produce(me.visual, me.vcgid, 'ADD_ENTRIES', me.entries);
            }

        });
         
    
        //change hardware handler (with undo functionality)
        me.visual.find("#signal-table").off("focus", ".ddl-hardware").on("focus", ".ddl-hardware", function () { me.last_hw = $(this).val(); })
            .off("change", ".ddl-hardware").on("change", ".ddl-hardware", function () { me.changeHardware($(this));});
     
        //get tooltip for specific address legends
        me.visual.find("#signal-table").off("mouseover", ".l").on("mouseover", ".l", function (e) { me.setSpecificLegendTitle($(e.target)); });

        //click handlers
        me.visual.find("#div-btn-add").off("click").on("click", function () { me.addNew(); }).button();
        me.visual.find("#signal-table").off("click", ".btn-clone").on("click", ".btn-clone", function(e) { me.clone($(e.target)); });
        me.visual.find("#signal-table").off("click", ".btn-delete").on("click", ".btn-delete", function (e) { me.visual.find($(e.target)).parents("li").remove(); me.filter();me.countErrors();});
        me.visual.find("#signal-table").off("click", ".btn-online-add").on("click", ".btn-online-add", function (e) { me.showOnlineAddr($(e.target), true); });
        me.visual.find("#signal-table").off("click", ".btn-online-delete").on("click", ".btn-online-delete", function (e) {me.showOnlineAddr($(e.target), false); });

        me.visual.find("#div-btn-save").off("click").on("click", function () {me.askSave();});



        me.visual.find("#div-btn-export").off("click").on("click", function () {
            //me.toggleWaiting(false, 0);
            //me.visual.find("#signal-table").html("");
            //me.countErrors();


            me.exportEntries();
        }).button();
      
        //show/hide the copy menu
        me.visual.find(".btn-copy-all").off("click").on("click", function () {me.toggleCopyMenu(me.visual.find("#div-signal-menu").is(":visible")); });

        me.initHeartbeat();

        me.fetchRuleCounter();

        me.selectUnit();

        // TODO MKU: .logs-popup class changed to logs-popup class!! check if there could be any other influences??
        // popup for sending tasks (delData, importData, etc)
        me.logsPopup = $("<div>").addClass("logs-popup").attr("id", "popupTasksDialog").css("overflow-y", "hidden").css("height", 715).dialog({
            open: function (event, ui) { },
            autoOpen: false, modal: true, width: 1100, height: 800,
            resizable: false, dialogClass: "modal-popup-dialog", title: "", closeOnEscape: true, position: { my: 'top+10%', at: 'top', of: window },
            buttons: [{ text: window._RESOURCES.JS_Com.close_lbl, click: function () { me.logsPopup.dialog('close'); return true; } }]
        });
        me.visual.find("#signal-table").off("click", ".btn-intense-log").on("click", ".btn-intense-log", function (e) {
       
            me.logsPopup.SingleLog({ invokeType: "addVisualBase", parameter: { Bsaid: $(e.target).data("bsaid") } });
            me.logsPopup.dialog('open');
        });

        //arrEntries[i].find(".btn-intense-log").show();
       
    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}

//menu events
//************

UnitAnalogEditor.prototype.showAll = function () {
    /// <summary>
    /// Shows all signals. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.parameter.blhid = 0;
        me.parameter.bluid = -1;

        me.fetchEntries();

        me.visual.find("#div-unit-viewer #lstUnit li").removeClass("active");
        me.visual.find(".select-entry-filter").removeClass("button-toggle-active");
        me.toggleImportList(me.visual.find("#div-btn-import"), false, false);
        me.visual.find("#div-btn-import").hide();



        return true;
    } catch (ex) { writeError('selectView', ex); return false; }
};


UnitAnalogEditor.prototype.reloadView = function () {
    /// <summary>
    /// Handles the shows/hides the selected entry fields on the rights side of the entry list
    /// optionally it loads the rules for all signal rules as well
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }


        alert();
        return true;
       
        var view = obj.data("type");
        me.selectView(obj);
        return true;
    } catch (ex) { writeError('reloadView', ex); return false; }
};


UnitAnalogEditor.prototype.selectView = function (obj) {
    /// <summary>
    /// Handles the shows/hides the selected entry fields on the rights side of the entry list
    /// optionally it loads the rules for all signal rules as well
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        var view = obj.data("type");

        me.visual.find(".addr, .docu, .others,.opcserver, .opcwrite,.intenselogging,.dm,.setext, .filecredentials, .bacnet, .rules, .pic, .zst").not("." + view).hide();
        me.visual.find("." + view).show();
        me.visual.find(".ignore." + view).hide();
        me.visual.find(".select-view").removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");

        if (view !== "rules") {
            //   me.visual.find("#signal-table li .rule").html("");
            me.cancelRules = true;
        } //else {
      
            //_VCMQ.produce(me.visual, me.vcgid, 'SHOW_RULES', (view === "rules"));

         me.showRules((view === "rules"));
        
         me.showPics((view === "pic"));

        me.lastView = view;

        return true;
    } catch (ex) { writeError('selectView', ex); return false; }
};

UnitAnalogEditor.prototype.selectHardware = function (obj) {
    /// <summary>
    /// Handles the selected hardware of the unit viewer
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        var blhid = obj.attr("id");
        blhid = blhid.replace('hardware_', '');

       
        me.blhid = blhid;
        me.parameter.blhid = parseInt(blhid, 10);
        me.parameter.bluid = -1;

        //if we want to get all rules we switch to the rule infos 
        if (me.parameter.blhid === -1 && me.visual.find("#div-btn-rules").hasClass("button-toggle-active")===false) {
            me.selectView(me.visual.find("#div-btn-rules"));
        }

        me.fetchEntries();

        me.visual.find("#div-unit-viewer #lstUnit li, .div-unit-viewer-rules").removeClass("active");
        obj.addClass("active");
        me.toggleImportList(me.visual.find("#div-btn-import"), false, false);
        me.visual.find("#div-btn-import").show();
        return true;
    } catch (ex) { writeError('selectHardware', ex); return false; }
};

UnitAnalogEditor.prototype.selectUnit = function () {
    /// <summary>
    /// Handles the selected hardware of the unit viewer
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

       
        var bluid = parseInt(me.visual.find("#div-unit-menu #ddl-unit-dest").val());
        if (isNaN(bluid)) {bluid = -1}
        me.blhid = 0;
        me.parameter.blhid = 0;
        me.parameter.bluid = bluid;

        me.fetchEntries();

        me.visual.find("#div-unit-viewer #lstUnit li, .div-unit-viewer-rules").removeClass("active");
       // obj.addClass("active");
        me.toggleImportList(me.visual.find("#div-btn-import"), false, false);
        me.visual.find("#div-btn-import").show();
        return true;
    } catch (ex) { writeError('selectUnit', ex); return false; }
};

UnitAnalogEditor.prototype.initCopyMenu = function () {
    /// <summary>
    /// This function shows/hides the copy menu which looks similar to an signal entry (below the list header)! <br/>
    /// It adds very simply keyup/click/change handler to all fields - on event a validation dialog box comes up ...
    /// and if yes - then all values of the selected column in the signal list get set to the according value in the copy meny
    /// NOTE: input fields react on the RETURN button;
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        var entry = me.visual.find("#div-signal-menu");
        entry.find(".addr-online .fld").show();
        entry.find(".l").hide();
        entry.find(".btn-clone, .btn-delete, .btn-online-add, .btn-online-delete").remove();
         entry.find(".txt-pic").attr("id", "mediaid" + parseInt(Math.random() * 100000, 10));
         entry.find(".txt-pic").vcGallery({
            customerid:  entry.find(".txt-pic").val(),
            mediaCategory: "SIGNAL",
            previewWidth: 50,
            previewHeight: 50,
            formItemWidth: 350,
            showDetails: true,
            onFileChanged: function() {
               me.askApplyMultiple( entry.find(".txt-pic"), 2);
                // me.countErrors();
            }
        });
                
      
        me.visual.find("#div-signal-menu").off("change", ".fld.ddl").on("change", ".fld.ddl", function (e) {
            me.askApplyMultiple($(e.target), 0);
            return true;
        });

        me.visual.find("#div-signal-menu").off("click", ".fld.chb").on("click", ".fld.chb", function (e) {
            me.askApplyMultiple($(e.target), 1);
            return true;
        });
        //on return
        me.visual.find("#div-signal-menu input.fld,#div-signal-menu textarea.fld").keyup(function (e) {
            if (e.keyCode !== 13) return false;
            me.askApplyMultiple($(e.target), 0);
            return true;
        });


        return true;
    } catch (ex) {
        me.writeError('initCopyMenu', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.askApplyMultiple = function (obj, type) {
    /// <summary>
    /// This function sets all values in the entry list to the according column of the copy menu <br/>
    /// NOTE: if the hardware got selected all entrie addresses get adopted as well 
    /// </summary>
    var me = this;
    var val;
    try {
        if (me.error) { return false; }

        if (type===1) {
            val = obj.prop("checked");
        } else { val = obj.val(); }

        //generate a selector based on all classes of the object in the copy menu ;-)
        var sClass = obj.clone().removeClass("new invalid dirty").attr('class').split(' ').join('.');
        //now find all entries with the same class in the entry list
        var items = me.visual.find("#signal-table .selected ." + sClass);
        //ignore unused fields
        items = items.filter(function () { return $(this).hasClass("unused") === false });


        if (type === 2) {
            obj = obj.parents(".pic");
        }

        //open the dialog
        me.openAskDialog(me.resources.shouldChangesGetApplied, { my: 'top-180px', at: 'top', of: obj }, function () {

            switch (type) {
                case 0:
                    items.val(val);
                    //if the hardware ddl was selected - adopt all had
                    if (items.hasClass("ddl-hardware")) { items.each(function () { me.adoptHardwareParameter($(this)); }); }
                    break;
                case 1:
                    items.prop("checked", val);
                    break;
                case 2:
                    items.val(val);
                    me.showPics(false);
                    me.showPics(true);
                    break;
            default:
            }
            //if (type===1) {
            //    items.prop("checked", val);
            //} else {
              
            //}
            items.removeClass("dirty").addClass("dirty");
            me.validateImport(sClass);

            me.countErrors();
            if (me.visual.find("#div-state").hasClass("error") === false) {
                me.visual.find("#div-btn-save").removeClass("active").addClass("active");
            }
        });

        return true;
    } catch (ex) {
        me.writeError('askApplyMultiple', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.toggleCopyMenu = function (bHide) {
    /// <summary>
    /// This function shows/hides the signal copy menu <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (bHide) {
            me.visual.find("#div-signal-menu").hide();
            me.visual.find("#div-signal-menu #chb-select-all").prop("checked", false);
            me.visual.find("#signal-table .selection .chb-selection").prop("checked", false).hide();
            me.visual.find("#signal-table .entry").removeClass("minify selected");

        } else {
            me.visual.find("#div-signal-menu").show();
            me.visual.find("#div-signal-menu #chb-select-all").prop("checked", false);
            me.visual.find("#signal-table .selection .chb-selection").prop("checked", false).show();
            me.visual.find("#signal-table .entry").removeClass("minify").addClass("minify");
        }
        me.adoptListHeight();

        return true;
    } catch (ex) {
        me.writeError('toggleCopyMenu', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.addNew = function () {
    /// <summary>
    /// This function clones the hidden template entry and adds it to the entry list <br/>
    /// </summary>
    var me = this;
    var list;
    var entry;
    try {
        if (me.error) { return false; }
        me.toggleWaiting(false, 0);
        list = me.visual.find("#signal-table");
        entry = me.visual.find("#div-signal-template>li").clone();

        entry.find(".txt-pic").attr("id", "mediaid" + parseInt(Math.random() * 100000, 10));
        entry.find(".bsaid").html("");

       if (me.parameter.blhid !== 0) {entry.find(".ddl-hardware").val(me.parameter.blhid);}
      
        //set online addressses and adopt hardware parameter
       me.showOnlineAddr(entry.find(".addr-online .btn-online-delete"), false);
       me.adoptHardwareParameter(entry.find(".ddl-hardware"), false);
       me.storeAdditionalFilterString(entry);
       entry.show();
       list.append(entry);
       list.show();
     
        me.validateImport("fld");
        me.filter();
        me.countErrors();
        //go to the end of the list
        list.animate({ scrollTop: list[0].scrollHeight - list.height() }, 50);

        return true;
    } catch (ex) {
        me.writeError('addnew', ex);return false;
    }

};

UnitAnalogEditor.prototype.clone = function (obj) {
    /// <summary>
    /// This function clones the selected entry and adds it to the entry list <br/>
    /// It adds a counter to the name until the name gets unique
    /// </summary>
    var me = this;
    var list, old, entry;
    try {
        if (me.error) { return false; }

        list = me.visual.find("#signal-table");

        old = me.visual.find(obj).parents("li");
        entry = old.clone();

        //we have to copy the current values from all ddl manually
        old.find(".ddl").each(function () { entry.find("." + $(this).attr('class').split(' ').join('.')).val($(this).val()); });
        //remove all data attributes
        entry.removeData("bsaid").removeData("infoid").removeData("bsahid").removeData("addrArchive").removeData("addrOnline");
        entry.removeAttr("data-bsaid").removeAttr("data-infoid").removeAttr("data-bsahid").removeAttr("data-addrArchive").removeAttr("data-addrOnline");
        entry.find(".txt-pic").attr("id", "mediaid" + parseInt(Math.random() * 100000, 10));
        entry.find(".txt-name").val(me.getNewName(entry, true));
        entry.find(".chb-validated").prop("checked", false);
        entry.find(".btn-delete").show();
        entry.find(".bsaid").html("");
        entry.find(".txt-opcsrv-nodeid,.txt-opcsrv-displayname").val("");
        entry.find(".chb-opcsrv-active,.chb-opcsrv-externalwrite").prop("checked", false);

        

        me.validate(entry.find(".txt-name"));
        me.storeAdditionalFilterString(entry);
        list.append(entry);

        me.filter();
        me.countErrors();
        //list.animate({ scrollTop: list[0].scrollHeight - list.height() }, 50);

        return true;
    } catch (ex) {
        me.writeError('clone', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.getNewName = function (entry, bNameExists) {
    /// <summary>
    /// This function adds a counter to the name until the name gets unique
        /// </summary>
        var me = this;
    var i = 0;
    var name, newName, names, list;
    try {
        if(me.error) { return false; }

        list = me.visual.find("#signal-table");
        //try to find a new, unique signal name by adding a counter
         name = entry.find(".txt-name").val().trim();

         if (bNameExists) {
              i++;
                newName = name + " " +i;
         } else {
             newName = name;
         }
         names = list.find(".txt-name").filter(function() { return $(this).val() === newName;});

         while (names.length > 0) {
             i++;
             newName = name + " " +i;
             // ReSharper disable once ClosureOnModifiedVariable
             names = list.find(".txt-name").filter(function() { return $(this).val() === newName;});
         }
       
        return newName;
        } catch (ex) {
            me.writeError('getNewName', ex);
        return "Error on generating Name";
        }

        };




//data handling
//************

UnitAnalogEditor.prototype.buildPager = function () {
    /// <summary>
    /// This function fetches new entries, generates the entry list and validates it <br/>
    /// </summary>
    var me = this;
  
    var p;
    var min=-1, max=0;
    try {
        
        me.visual.find("#div-paging").html("").hide();
        if (me.entries.length > 100) {
            while (max < (me.entries.length-1)) {

                if (((me.entries.length-1) - max) < 100) {
                    min += 100;
                    max = me.entries.length - 1;

                    p = $("<div>").addClass("btn-paging button-toggle vc-grid-1col")
                        .data("min", min).data("max", max).html((min + 1) + " - " + (max +1));

                    me.visual.find("#div-paging").append(p);
                } else {
                   // console.info(min);
                    if (min === -1) {
                        min = 0;
                        max = 99;
                        //    rest = 99;
                    } else {
                        min += 100;
                        max += 100;
                        //rest = 99;
                    }

                    p = $("<div>").addClass("btn-paging button-toggle vc-grid-1col")
                        .data("min", min).data("max", max).html((min + 1) + " - " + (max + 1));

                    me.visual.find("#div-paging").append(p);
                }


                
            }

        }
       
        p = $("<div>").addClass("btn-paging button-toggle vc-grid-1col ").data("min", 0).data("max", me.entries.length-1).html(me.resources.all);
        me.visual.find("#div-paging").append(p);
        me.visual.find("#div-paging .btn-paging:first").addClass("button-toggle-active");
        if (me.entries.length > 100) {me.visual.find("#div-paging").show();}

        return true;

    } catch (ex) {
        me.writeError('buildPager', ex);
        return false;
    }

};



UnitAnalogEditor.prototype.fetchEntries = function () {
    /// <summary>
    /// This function fetches new entries, generates the entry list and validates it <br/>
    /// </summary>
    var me = this;
    var param ;
    try {
        if (me.error) { return false; }
        me.toggleWaiting(true, 0);
        me.toggleCopyMenu(true);
          
        me.visual.find("#signal-table").html("").hide();
       
        param = { "type": 0, "Blhid": me.parameter.blhid,  "UnitId": me.parameter.bluid }


     
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function(result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                }
              

                if (result.length === 0) {
                    me.toggleWaiting(true, 3);
                    return true;
                }
                //save the entries for later
                me.entries = result;
                result = null;
                me.buildPager();

            //add the entries
            _VCMQ.produce(me.visual, me.vcgid, 'ADD_ENTRIES', me.entries);
            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('fetchEntries', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.exportEntries = function () {
    /// <summary>
    /// This function fetches new entries, generates the entry list and validates it <br/>
    /// </summary>
    var me = this;
    var param;
    try {
        if (me.error) { return false; }
        //me.toggleWaiting(true, 0);
        //me.toggleCopyMenu(true);

        me.visual.find("#div-export-link").hide();

        param = { "type": 0, "Blhid": me.parameter.blhid }

        window.VisualCoreService.exportData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === null) { me.showMessage(me.resources.err_loadData, true); }

                me.visual.find("#div-export-link a").attr("href", result);
                me.visual.find("#div-export-link").show();
                result = null;
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('exportEntries', ex);
        return false;
    }

};





UnitAnalogEditor.prototype.add = function (list, isImport) {
    /// <summary>
    /// This function receives the entry data list and generates signal entries out of it <br/>
    /// for each entry it clones the hidden template entry, sets the values and sets the values as old-data-attrbutes for saving as well.
    /// Lot's of work, but pretty much always the same
    /// </summary>
    var me = this;
    var entry;
    var i,j;
    var template;
    var tmpList = [];
    var arrEntries;
    var min, max;
    var paging;
    try {
        if (me.error) { return false; }


        //console.info(list);


      
        arrEntries = new Array(list.length);
         template = me.visual.find("#div-signal-template li").clone();
        template.find(".fld").removeData("type").removeAttr("data-type").removeAttr("data-min").removeAttr("data-max");



        if (isImport === false) {
            paging = me.visual.find("#div-paging .button-toggle-active");
            min = parseInt(paging.data("min"));
            max = parseInt(paging.data("max"));
            if (max >= (list.length - 1)) max = list.length - 1;
        } else {
            min = 0;
            max = list.length - 1;
        
        }
      

        for (i = min; i <= max; i++) {
         
            arrEntries[i] = template.clone();


   
            //set all data ids here
            arrEntries[i].data("bsaid", list[i].Main.Id);
            if (isImport===false) {arrEntries[i].find(".bsaid").html(list[i].Main.Id);}
          

            arrEntries[i].find(".main").prop("title","ID: " + list[i].Main.Id);
            arrEntries[i].data("infoid", list[i].Info.Id);
            arrEntries[i].data("bsahid", list[i].Hardware.Id);

           
            //generate the address entries
            if (list[i].Hardware.Blhid !== null) {
              
                //addr
                if (list[i].Addresses.length > 0) {
                    if (list[i].Addresses[0].AddrTypeID === 1) {
                        arrEntries[i].data("addrArchive", list[i].Addresses[0].Id);
                        me.addAddress(arrEntries[i], "archive", list[i].Addresses[0]);
                    }
                }
                if (list[i].Addresses.length > 1) {
                    if (list[i].Addresses[1].AddrTypeID === 2) {
                        arrEntries[i].data("addrOnline", list[i].Addresses[1].Id);
                        arrEntries[i].find(".addr-online").addClass("addOnline");
                        me.addAddress(arrEntries[i], "online", list[i].Addresses[1]);
                    }
                } else {
                    arrEntries[i].find(".addr-online .fld").remove();
                    arrEntries[i].find(".addr-online ").removeClass("empty").addClass("empty");
                }

            }
          
            //set the main attributes
            arrEntries[i].find(".chb-active").prop("checked", list[i].Main.Active);
            arrEntries[i].find(".chb-active").data("old", list[i].Main.Active);

            arrEntries[i].find(".txt-name").val(list[i].Info.Name);
            arrEntries[i].find(".txt-name").data("old", list[i].Info.Name);

            arrEntries[i].find(".ddl-dims").val(list[i].Info.Bdimsid);
            arrEntries[i].find(".ddl-dims").data("old", list[i].Info.Bdimsid);

            arrEntries[i].find(".ddl-signal-group").val(list[i].Info.Bsagid);
            arrEntries[i].find(".ddl-signal-group").data("old", list[i].Info.Bsagid);

            arrEntries[i].find(".ddl-signal-type").val(list[i].Main.Bstypeid);
            arrEntries[i].find(".ddl-signal-type").data("old", list[i].Main.Bstypeid);

            arrEntries[i].find(".chb-sum-signal").prop("checked", list[i].Main.IsSumSignal);
            arrEntries[i].find(".chb-sum-signal").data("old", list[i].Main.IsSumSignal);

            arrEntries[i].find(".ddl-zst").val(list[i].Main.ZstType);
            arrEntries[i].find(".ddl-zst").data("old", list[i].Main.ZstType);

            arrEntries[i].find(".txt-aks").val(list[i].Main.Aks);
            arrEntries[i].find(".txt-aks").data("old", list[i].Main.Aks);

            //it the signal is no signal rule set the hardware attributes
            if (list[i].Hardware.Blhid !== null) {





                //sub
                arrEntries[i].find(".chb-validated").prop("checked", list[i].Hardware.Validated);
                arrEntries[i].find(".chb-validated").data("old", list[i].Hardware.Validated);

                arrEntries[i].find(".ddl-hardware").val(list[i].Hardware.Blhid);
                arrEntries[i].find(".ddl-hardware").data("old", list[i].Hardware.Blhid);

                arrEntries[i].find(".ddl-meter").val(list[i].Hardware.Blhmid);
                arrEntries[i].find(".ddl-meter").data("old", list[i].Hardware.Blhmid);

                arrEntries[i].find(".chb-measure").prop("checked", list[i].Hardware.Measure);
                arrEntries[i].find(".chb-measure").data("old", list[i].Hardware.Measure);

                arrEntries[i].find(".a-hw-desc").val(list[i].Hardware.Description.replace(/<br\s*[\/]?>/gi, '\n'));
                arrEntries[i].find(".a-hw-desc").data("old", list[i].Hardware.Description.replace(/<br\s*[\/]?>/gi, '\n'));

                arrEntries[i].find(".txt-smooth").val(list[i].Hardware.Smooth);
                arrEntries[i].find(".txt-smooth").data("old", list[i].Hardware.Smooth);

                arrEntries[i].find(".chb-validated").prop("checked", list[i].Hardware.Validated);
                arrEntries[i].find(".chb-validated").data("old", list[i].Hardware.Validated);

                arrEntries[i].find(".txt-pic").val(list[i].Hardware.MediaID);
                arrEntries[i].find(".txt-pic").data("old", list[i].Hardware.MediaID);

            } else {
                arrEntries[i].find(".ddl-hardware").val(-1);
                arrEntries[i].find(".ddl-hardware").data("old", -1);
            }

            if (list[i].Info.Description === null) {
                list[i].Info.Description = "";
            }

            if (isImport === false) {
                // opc client
                arrEntries[i].find(".txt-opccl-namespace").val(list[i].OpcSettings.Client.Namespace);
                arrEntries[i].find(".txt-opccl-namespace").data("old", list[i].OpcSettings.Client.Namespace);
                arrEntries[i].find(".txt-opccl-nodeid").val(list[i].OpcSettings.Client.NodeId);
                arrEntries[i].find(".txt-opccl-nodeid").data("old", list[i].OpcSettings.Client.NodeId);

                //opc server
                arrEntries[i].find(".chb-opcsrv-active").prop("checked", list[i].OpcSettings.Server.Active);
                arrEntries[i].find(".chb-opcsrv-active").data("old", list[i].OpcSettings.Server.Active);
                arrEntries[i].find(".txt-opcsrv-nodeid").val(list[i].OpcSettings.Server.NodeId);
                arrEntries[i].find(".txt-opcsrv-nodeid").data("old", list[i].OpcSettings.Server.NodeId);
                arrEntries[i].find(".txt-opcsrv-displayname").val(list[i].OpcSettings.Server.DisplayName);
                arrEntries[i].find(".txt-opcsrv-displayname").data("old", list[i].OpcSettings.Server.DisplayName);

                if (list[i].OpcSettings.Server.DataType.length == 0) list[i].OpcSettings.Server.DataType = "double";

                arrEntries[i].find(".txt-opcsrv-datatype").val(list[i].OpcSettings.Server.DataType);
                arrEntries[i].find(".txt-opcsrv-datatype").data("old", list[i].OpcSettings.Server.DataType);
                arrEntries[i].find(".chb-opcsrv-externalwrite").prop("checked", list[i].OpcSettings.Server.ExternalWrite);
                arrEntries[i].find(".chb-opcsrv-externalwrite").data("old", list[i].OpcSettings.Server.ExternalWrite);
                //opc write
                arrEntries[i].find(".chb-opcwrite-active").prop("checked", list[i].OpcSettings.Write.Active);
                arrEntries[i].find(".chb-opcwrite-active").data("old", list[i].OpcSettings.Write.Active);
                arrEntries[i].find(".txt-opcwrite-url").val(list[i].OpcSettings.Write.Url);
                arrEntries[i].find(".txt-opcwrite-url").data("old", list[i].OpcSettings.Write.Url);
                arrEntries[i].find(".txt-opcwrite-namespace").val(list[i].OpcSettings.Write.Namespace);
                arrEntries[i].find(".txt-opcwrite-namespace").data("old", list[i].OpcSettings.Write.Namespace);
                arrEntries[i].find(".txt-opcwrite-nodeid").val(list[i].OpcSettings.Write.NodeId);
                arrEntries[i].find(".txt-opcwrite-nodeid").data("old", list[i].OpcSettings.Write.NodeId);


              
                ////intense logging
                arrEntries[i].find(".chb-intenselogging-active").prop("checked", list[i].Extended.Logging.Active);
                arrEntries[i].find(".chb-intenselogging-active").data("old", list[i].Extended.Logging.Active);
                arrEntries[i].find(".txt-intenselogging-daysActive").val(list[i].Extended.Logging.DaysActive);
                arrEntries[i].find(".txt-intenselogging-daysActive").data("old", list[i].Extended.Logging.DaysActive);
                arrEntries[i].find(".txt-intenselogging-daysBeforeDeleted").val(list[i].Extended.Logging.DaysBeforeDeleted);
                arrEntries[i].find(".txt-intenselogging-daysBeforeDeleted").data("old", list[i].Extended.Logging.DaysBeforeDeleted);
                arrEntries[i].find(".btn-intense-log").data("bsaid", list[i].Main.Id);
                if (list[i].Extended.Logging.Active) {
                    arrEntries[i].find(".btn-intense-log").show();
                } else {
                    arrEntries[i].find(".btn-intense-log").hide();
                }

                //we show the end dates (and expired dates) ...
                var text = $("<div>");
                if (list[i].Extended.Logging.StartDate.length > 0) {
                    
                    var endDate = moment(list[i].Extended.Logging.StartDate, "DD.MM.YYYY").add(list[i].Extended.Logging.DaysActive, "days");
                    var divEnd = $("<div>").css("display", "inline-table").html(endDate.format("DD.MM.YYYY"));
                    if (endDate.diff(moment(getCurrentTimestamp(), "DD.MM.YYYY"), "days") <0) {
                        divEnd.css("text-decoration", "line-through").css("color", "#bbb");
                    }
                    text.append(divEnd);
                    var delDate = moment(list[i].Extended.Logging.StartDate, "DD.MM.YYYY").add(list[i].Extended.Logging.DaysActive + list[i].Extended.Logging.DaysBeforeDeleted, "days");
                    var divDel = $("<div>").css("display", "inline-table").css("margin-left", 22).html(delDate.format("DD.MM.YYYY"));
                    if (delDate.diff(moment(getCurrentTimestamp(), "DD.MM.YYYY"), "days") < 0) {
                        divDel.css("text-decoration", "line-through").css("color", "#bbb");
                    }
                    text.append(divDel);


                } else {
                    text.html("");
                }
                arrEntries[i].find(".div-intenselogging-enddate").html(text);

              
                var zstCorr = list[i].Extended.ZstCorrection.StartValue.toString().replace(".", ",");
              
                //extended zst correction
                //arrEntries[i].find(".txt-setext-zst-startdate").val(list[i].Extended.ZstCorrection.StartDate);
                //arrEntries[i].find(".txt-setext-zst-startdate").data("old", list[i].Extended.ZstCorrection.StartDate);
                arrEntries[i].find(".txt-setext-zst-startvalue").val(zstCorr);
                arrEntries[i].find(".txt-setext-zst-startvalue").data("old", zstCorr);
                //extended meter readings
                arrEntries[i].find(".txt-setext-movereadingtimestamp").val(list[i].Extended.MeterReadings.MoveReadingTimestamp);
                arrEntries[i].find(".txt-setext-movereadingtimestamp").data("old", list[i].Extended.MeterReadings.MoveReadingTimestamp);
                //geo location
                arrEntries[i].find(".txt-setext-geo-lat").val(list[i].Extended.GeoLocation.Lat);
                arrEntries[i].find(".txt-setext-geo-lat").data("old", list[i].Extended.GeoLocation.Lat);
                arrEntries[i].find(".txt-setext-geo-lon").val(list[i].Extended.GeoLocation.Lon);
                arrEntries[i].find(".txt-setext-geo-lon").data("old", list[i].Extended.GeoLocation.Lon);
                //file credentials
                arrEntries[i].find(".txt-filecredentials-test").val(list[i].FileCredentials.Test);
                arrEntries[i].find(".txt-filecredentials-test").data("old", list[i].FileCredentials.Test);

                //bacnet
                arrEntries[i].find(".txt-bacnet-test").val(list[i].Bacnet.Test);
                arrEntries[i].find(".txt-bacnet-test").data("old", list[i].Bacnet.Test);

                //dm

                arrEntries[i].find(".ddl-dmdid").val(list[i].Main.Dmdid);
                arrEntries[i].find(".ddl-dmdid").data("old", list[i].Main.Dmdid);

                arrEntries[i].find(".ddl-dmdstid").val(list[i].Main.Dmdstid);
                arrEntries[i].find(".ddl-dmdstid").data("old", list[i].Main.Dmdstid);

            }
            //docu 
            arrEntries[i].find(".a-desc").val(list[i].Info.Description.replace(/<br\s*[\/]?>/gi, '\n'));
            arrEntries[i].find(".a-desc").data("old", list[i].Info.Description.replace(/<br\s*[\/]?>/gi, '\n'));

            //others
            arrEntries[i].find(".a-varname").val(list[i].Main.Varname);
            arrEntries[i].find(".a-varname").data("old", list[i].Main.Varname);

            arrEntries[i].find(".ddl-allowed-interval").val(list[i].Main.AllowedInterval);
            arrEntries[i].find(".ddl-allowed-interval").data("old", list[i].Main.AllowedInterval);


            arrEntries[i].find(".ddl-priorityid").val(list[i].Main.PriorityId);
            arrEntries[i].find(".ddl-priorityid").data("old", list[i].Main.PriorityId);

            arrEntries[i].find(".txt-delay").val(list[i].Main.ValidationDelay);
            arrEntries[i].find(".txt-delay").data("old", list[i].Main.ValidationDelay);

            arrEntries[i].find(".txt-longterm-delay").val(list[i].Main.LongTermDelay);
            arrEntries[i].find(".txt-longterm-delay").data("old", list[i].Main.LongTermDelay);

            arrEntries[i].find(".txt-const-value").val(list[i].Main.ConstValue);
            arrEntries[i].find(".txt-const-value").data("old", list[i].Main.ConstValue);

            arrEntries[i].find(".chb-internal").prop("checked", list[i].Main.Internal);
            arrEntries[i].find(".chb-internal").data("old", list[i].Main.Internal);

            arrEntries[i].find(".chb-producer").prop("checked", list[i].Main.IsProducer);
            arrEntries[i].find(".chb-producer").data("old", list[i].Main.IsProducer);

            arrEntries[i].find(".chb-plaus-to-chart").prop("checked", list[i].Main.PlausAsChartLimit);
            arrEntries[i].find(".chb-plaus-to-chart").data("old", list[i].Main.PlausAsChartLimit);
                                                  
            if (isImport === false) {
                arrEntries[i].removeClass("new");
                arrEntries[i].find(".dirty").removeClass("dirty");
                arrEntries[i].find(".btn-delete").hide();
                //adopt the hardware parameters
                me.adoptHardwareParameter(arrEntries[i].find(".ddl-hardware"), false);
            } else {
               

                //get a new name
                arrEntries[i].find(".txt-name").val(me.getNewName(arrEntries[i], false));
                me.validate(arrEntries[i].find(".txt-name"));
                arrEntries[i].find(".ddl-hardware").val(me.parameter.blhid);
                //adopt the hardware parameters
                me.adoptHardwareParameter(arrEntries[i].find(".ddl-hardware"), false);

                arrEntries[i].find(".fld").removeData("old").removeAttr("data-old");
                arrEntries[i].removeData("bsaid").removeData("infoid").removeData("bsahid").removeData("addrArchive").removeData("addrOnline");
                arrEntries[i].removeAttr("data-bsaid").removeAttr("data-infoid").removeAttr("data-bsahid").removeAttr("data-addrArchive").removeAttr("data-addrOnline");
              

            }

            me.storeAdditionalFilterString(arrEntries[i]);
            //store it to a temporary list (for speeding up)
            tmpList.push(arrEntries[i]);
            arrEntries[i].show();
          
        }
      

        //fill the arrEntries[i] list
        me.visual.find("#signal-table").append(tmpList);
       
        //test - delete all ddl options except the selected
         //me.visual.find("#signal-table .fld.ddl").find('option').not(":selected").remove().end();

        me.visual.find("#signal-table .addOnline input, #signal-table .addOnline .ddl, #signal-table .addOnline .btn-online-delete").show();
        me.visual.find("#signal-table .addOnline .btn-online-add").hide();
        me.visual.find("#signal-table .addOnline").removeClass("addOnline");

        _VCMQ.produce(me.visual, me.vcgid, 'FINISH_ADDING', isImport);

        template = null;
        tmpList = null;
        list = null;
   
        return true;
    } catch (ex) {
        me.writeError('add', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.addAddress = function (entry, sClass, addr) {
    /// <summary>
    /// This function generates one single address part of an entry <br/>
    /// </summary>
    var me = this;
    var mkorr;
    var l;
    try {
        if (me.error) { return false; }
      
        entry.find(".ddl-" + sClass + "-dims").val(addr.Bdimsid);
        entry.find(".ddl-" + sClass + "-dims").data("old", addr.Bdimsid);

        entry.find(".ddl-" + sClass + "-meter-type").val(addr.Blhmtid);
        entry.find(".ddl-" + sClass + "-meter-type").data("old", addr.Blhmtid);

        entry.find(".ddl-" + sClass + "-meter-format").val(addr.Blhmfid);
        entry.find(".ddl-" + sClass + "-meter-format").data("old", addr.Blhmfid);

        mkorr = addr.MKorr + "";

        if (mkorr.indexOf("e-") > -1) {
            l = parseInt(mkorr.substring(mkorr.indexOf("e-") + 2, mkorr.length));
            mkorr = parseFloat(mkorr).toFixed(l);
        } 

        entry.find(".txt-" + sClass + "-mkorr").val((mkorr + "").replace(".", ","));
        entry.find(".txt-" + sClass + "-mkorr").data("old", (mkorr + "").replace(".", ","));

        entry.find(".txt-" + sClass + "-skorr").val((addr.SKorr + "").replace(".", ","));
        entry.find(".txt-" + sClass + "-skorr").data("old", (addr.SKorr + "").replace(".", ","));

        entry.find(".txt-" + sClass + "-addr").val(addr.Addr);
        entry.find(".txt-" + sClass + "-addr").data("old", addr.Addr);

        entry.find(".txt-" + sClass + "-reg").val(addr.Reg);
        entry.find(".txt-" + sClass + "-reg").data("old", addr.Reg);

        entry.find(".txt-" + sClass + "-len").val(addr.Len);
        entry.find(".txt-" + sClass + "-len").data("old", addr.Len);

        entry.find(".txt-" + sClass + "-funcreg").val(addr.Funcreg);
        entry.find(".txt-" + sClass + "-funcreg").data("old", addr.Funcreg);

        entry.find(".txt-" + sClass + "-highlow").val(addr.Highlow);
        entry.find(".txt-" + sClass + "-highlow").data("old", addr.Highlow);

        entry.find(".txt-" + sClass + "-interval").val(addr.Interval);
        entry.find(".txt-" + sClass + "-interval").data("old", addr.Interval);

        entry.find(".txt-" + sClass + "-hw-minmes").val(addr.Minmes);
        entry.find(".txt-" + sClass + "-hw-minmes").data("old", addr.Minmes);

        entry.find(".txt-" + sClass + "-hw-maxmes").val(addr.Maxmes);
        entry.find(".txt-" + sClass + "-hw-maxmes").data("old", addr.Maxmes);

   

        return true;
    } catch (ex) {
        me.writeError('addAddress', ex); return false;

    }

};

UnitAnalogEditor.prototype.askSave = function () {
    /// <summary>
    /// This function opens a validation dialog of more than 1 signal are going to be saved <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
      
        if (me.visual.find("#div-btn-save").hasClass("active") === false) { return false }
      
        if (me.visual.find("#signal-table li").length > 1) {
            me.openAskDialog(me.resources.shouldChangesGetApplied, { my: 'left-330px', at: 'left', of: me.visual.find("#div-btn-save") }, function () { me.save() }, function () {
                me.visual.find("#signal-table").html("");
                me.fetchEntries();
            });
        } else {
            me.save();
        }
        return true;
    } catch (ex) {
        me.writeError('askSave', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.save = function () {
    /// <summary>
    /// This function generates the signal entry list for saving. <br/>
    /// The list is pretty similar to the loading list but has additional 'old' entries as well.
    /// When an entry/attribute got edited the 'old' entry gets set as well - it is used to decide weather an entry was changed and it is used for the history entry as well.
    /// </summary>
    var me = this;
    var list = [];
    var signal = {}, main = {}, oldMain = {}, info = {}, oldInfo = {}, hw = {}, oldHw = {}, addrRet = {}, opcSettings = {}, oldOpcSettings = {}, extended = {}, oldExtended = {}, fileCredentials = {}, oldFileCredentials = {}, bacnet = {}, oldBacnet = {};
    var entry, entries;
    var dirtyMain = false, dirtyInfo = false, dirtyHw = false, dirtyAddrArchive = false, dirtyAddrOnline = false;
    try {
      
        if (me.error) { return false; }
        if (me.visual.find("#div-btn-save").hasClass("active") === false) { return false }
    
        entries = me.visual.find("#signal-table>li");
      
        entries.each(function() {
            entry = $(this);
            signal = {}; main = {}, oldMain = {}; info = {}, oldInfo = {}; hw = {}, oldHw = {};
           
            opcSettings = {};
            opcSettings.Client = {};
            opcSettings.Server = {};
            opcSettings.Write = {};
            oldOpcSettings = {};
            oldOpcSettings.Client = {};
            oldOpcSettings.Server = {};
            oldOpcSettings.Write = {};

            extended = {};
            extended.MeterReadings = {};
            extended.ZstCorrection = {};
            extended.GeoLocation = {};
            extended.Logging = {};

            oldExtended = {};
            oldExtended.MeterReadings = {};
            oldExtended.ZstCorrection = {};
            oldExtended.GeoLocation = {};
            oldExtended.Logging = {};

            fileCredentials = {};
            oldFileCredentials = {};
            bacnet = {};
            oldBacnet = {};

            signal.blhid = entry.find(".ddl-hardware").val();


            //set bsaid and data status
            if (typeof(entry.data("bsaid")) === "undefined") {
                main.Status = 1; // add new
                signal.bsaid = -1;
            } else {
                main.Id = entry.data("bsaid");
                main.Status = 2; // edit
                signal.bsaid = main.Id;
            }

            dirtyMain = false;
            //DB-Table Bluaul.signal_analog
            if (entry.find(".chb-active").prop("checked") !== entry.find(".chb-active").data("old")) {
                main.Active = entry.find(".chb-active").prop("checked");
                if (main.Status === 2) { oldMain.Active = entry.find(".chb-active").data("old"); }
                dirtyMain = true;
            } 
            if (parseInt(entry.find(".ddl-signal-type").val(), 10) !== parseInt(entry.find(".ddl-signal-type").data("old"), 10)) {
                main.Bstypeid = entry.find(".ddl-signal-type").val();
                if (main.Status === 2) { oldMain.Bstypeid = entry.find(".ddl-signal-type").data("old"); }
                dirtyMain = true;
            }

            if (entry.find(".a-varname").val() !== entry.find(".a-varname").data("old")) {
                main.Varname = entry.find(".a-varname").val();
                if (main.Status === 2) { oldMain.Varname = entry.find(".a-varname").data("old"); }
                dirtyMain = true;
            }
            if (entry.find(".chb-sum-signal").prop("checked") !== entry.find(".chb-sum-signal").data("old")) {
                main.IsSumSignal = entry.find(".chb-sum-signal").prop("checked");
                if (main.Status === 2) { oldMain.IsSumSignal = entry.find(".chb-sum-signal").data("old"); }
                dirtyMain = true;
            }
            if (parseInt(entry.find(".txt-const-value").val(), 10) !== parseInt(entry.find(".txt-const-value").data("old"), 10)) {
                main.ConstValue = entry.find(".txt-const-value").val();
                if (main.Status === 2) { oldMain.ConstValue = entry.find(".txt-const-value").data("old"); }
                dirtyMain = true;
            }
            if (parseInt(entry.find(".ddl-zst").val(), 10) !== parseInt(entry.find(".ddl-zst").data("old"), 10)) {
                main.ZstType = entry.find(".ddl-zst").val();
                if (main.Status === 2) { oldMain.ZstType = entry.find(".ddl-zst").data("old"); }
                dirtyMain = true;
            }
            if (entry.find(".chb-producer").prop("checked") !== entry.find(".chb-producer").data("old")) {
                main.IsProducer = entry.find(".chb-producer").prop("checked");
                if (main.Status === 2) { oldMain.IsProducer = entry.find(".chb-producer").data("old"); }
                dirtyMain = true;
            }
            if (parseInt(entry.find(".txt-delay").val(), 10) !== parseInt(entry.find(".txt-delay").data("old"), 10)) {
                main.ValidationDelay = entry.find(".txt-delay").val();
                if (main.Status === 2) { oldMain.ValidationDelay = entry.find(".txt-delay").data("old"); }
                dirtyMain = true;
            }
            if (parseInt(entry.find(".txt-longterm-delay").val(), 10) !== parseInt(entry.find(".txt-longterm-delay").data("old"), 10)) {
                main.LongTermDelay = entry.find(".txt-longterm-delay").val();
                if (main.Status === 2) { oldMain.LongTermDelay = entry.find(".txt-longterm-delay").data("old"); }
                dirtyMain = true;
            }
            if (parseInt(entry.find(".ddl-allowed-interval").val(), 10) !== parseInt(entry.find(".ddl-allowed-interval").data("old"), 10)) {
                main.AllowedInterval = entry.find(".ddl-allowed-interval").val();
                if (main.Status === 2) { oldMain.AllowedInterval = entry.find(".ddl-allowed-interval").data("old"); }
                dirtyMain = true;
            }


            if (parseInt(entry.find(".ddl-priorityid").val(), 10) !== parseInt(entry.find(".ddl-priorityid").data("old"), 10)) {
                main.PriorityId = entry.find(".ddl-priorityid").val();
                if (main.Status === 2) { oldMain.PriorityId = entry.find(".ddl-priorityid").data("old"); }
                dirtyMain = true;
            }




            if (entry.find(".chb-internal").prop("checked") !== entry.find(".chb-internal").data("old")) {
                main.Internal = entry.find(".chb-internal").prop("checked");
                if (main.Status === 2) { oldMain.Internal = entry.find(".chb-internal").data("old"); }
                dirtyMain = true;
            }
            if (entry.find(".chb-plaus-to-chart").prop("checked") !== entry.find(".chb-plaus-to-chart").data("old")) {
                main.PlausAsChartLimit = entry.find(".chb-plaus-to-chart").prop("checked");
                if (main.Status === 2) { oldMain.PlausAsChartLimit = entry.find(".chb-plaus-to-chart").data("old"); }
                dirtyMain = true;
            }


            if (entry.find(".txt-aks").val() !== entry.find(".txt-aks").data("old")) {
                main.Aks = entry.find(".txt-aks").val();
                if (main.Status === 2) { oldMain.Aks = entry.find(".txt-aks").data("old"); }
                dirtyMain = true;
            }

            if (parseInt(entry.find(".ddl-dmdid").val(), 10) !== parseInt(entry.find(".ddl-dmdid").data("old"), 10)) {
                main.Dmdid = entry.find(".ddl-dmdid").val();
                if (main.Status === 2) { oldMain.Dmdid = entry.find(".ddl-dmdid").data("old"); }
                dirtyMain = true;
            }

            if (parseInt(entry.find(".ddl-dmdstid").val(), 10) !== parseInt(entry.find(".ddl-dmdstid").data("old"), 10)) {
                main.Dmdstid = entry.find(".ddl-dmdstid").val();
                if (main.Status === 2) { oldMain.Dmdstid = entry.find(".ddl-dmdstid").data("old"); }
                dirtyMain = true;
            }



           //OPC-settings
            //if any opc settings has changed we have to save everything
            if (
            
                trimAll(entry.find(".txt-opccl-namespace").val()) !== entry.find(".txt-opccl-namespace").data("old") ||
                trimAll(entry.find(".txt-opccl-nodeid").val()) !== entry.find(".txt-opccl-nodeid").data("old") ||

                entry.find(".chb-opcsrv-active").prop("checked") !== entry.find(".chb-opcsrv-active").data("old") ||
                trimAll(entry.find(".txt-opcsrv-nodeid").val()) !== entry.find(".txt-opcsrv-nodeid").data("old") ||
                trimAll(entry.find(".txt-opcsrv-displayname").val()) !== entry.find(".txt-opcsrv-displayname").data("old") ||

                trimAll(entry.find(".txt-opcsrv-datatype").val()) !== entry.find(".txt-opcsrv-datatype").data("old") ||
                entry.find(".chb-opcsrv-externalwrite").prop("checked") !== entry.find(".chb-opcsrv-externalwrite").data("old") ||

                entry.find(".chb-opcwrite-active").prop("checked") !== entry.find(".chb-opcwrite-active").data("old") ||
                trimAll(entry.find(".txt-opcwrite-url").val()) !== entry.find(".txt-opcwrite-url").data("old") ||
                trimAll(entry.find(".txt-opcwrite-namespace").val()) !== entry.find(".txt-opcwrite-namespace").data("old") ||
                entry.find(".txt-opcwrite-nodeid").val() !== entry.find(".txt-opcwrite-nodeid").data("old")


            ) {

                opcSettings.Client.Namespace = trimAll(entry.find(".txt-opccl-namespace").val());
                if (main.Status === 2) { oldOpcSettings.Client.Namespace = entry.find(".txt-opccl-namespace").data("old"); }
                opcSettings.Client.NodeId = trimAll(entry.find(".txt-opccl-nodeid").val());
                if (main.Status === 2) { oldOpcSettings.Client.NodeId = entry.find(".txt-opccl-nodeid").data("old"); }



                opcSettings.Server.Active = entry.find(".chb-opcsrv-active").prop("checked");
                if (main.Status === 2) { oldOpcSettings.Server.Active = entry.find(".chb-opcsrv-active").data("old"); }
                opcSettings.Server.NodeId = trimAll(entry.find(".txt-opcsrv-nodeid").val());
                if (main.Status === 2) { oldOpcSettings.Server.NodeId = entry.find(".txt-opcsrv-nodeid").data("old"); }
                opcSettings.Server.DisplayName = trimAll(entry.find(".txt-opcsrv-displayname").val());
                if (main.Status === 2) { oldOpcSettings.Server.DisplayName = entry.find(".txt-opcsrv-displayname").data("old"); }
                opcSettings.Server.DataType = trimAll(entry.find(".txt-opcsrv-datatype").val());
                if (main.Status === 2) { oldOpcSettings.Server.DataType = entry.find(".txt-opcsrv-datatype").data("old"); }
                opcSettings.Server.ExternalWrite = entry.find(".chb-opcsrv-externalwrite").prop("checked");
                if (main.Status === 2) { oldOpcSettings.Server.ExternalWrite = entry.find(".chb-opcsrv-externalwrite").data("old"); }


                opcSettings.Write.Active = entry.find(".chb-opcwrite-active").prop("checked");
                if (main.Status === 2) { oldOpcSettings.Write.Active = entry.find(".chb-opcwrite-active").data("old"); }
                opcSettings.Write.Url = trimAll(entry.find(".txt-opcwrite-url").val());
                if (main.Status === 2) { oldOpcSettings.Write.Url = entry.find(".txt-opcwrite-url").data("old"); }
                opcSettings.Write.Namespace = trimAll(entry.find(".txt-opcwrite-namespace").val());
                if (main.Status === 2) { oldOpcSettings.Write.Namespace = entry.find(".txt-opcwrite-namespace").data("old"); }
                opcSettings.Write.NodeId = trimAll(entry.find(".txt-opcwrite-nodeid").val());
                if (main.Status === 2) { oldOpcSettings.Write.NodeId = entry.find(".txt-opcwrite-nodeid").data("old"); }

                dirtyMain = true;



            } else {
                opcSettings = null;
            }


         

            //if any extended settings has changed we have to save everything
            if (
             
                trimAll(entry.find(".txt-setext-zst-startvalue").val()) != entry.find(".txt-setext-zst-startvalue").data("old") ||
                trimAll(entry.find(".txt-setext-movereadingtimestamp").val()) != entry.find(".txt-setext-movereadingtimestamp").data("old") ||
                trimAll(entry.find(".txt-setext-geo-lat").val()) != entry.find(".txt-setext-geo-lat").data("old") ||
                trimAll(entry.find(".txt-setext-geo-lon").val()) != entry.find(".txt-setext-geo-lon").data("old") ||
                entry.find(".chb-intenselogging-active").prop("checked") != entry.find(".chb-intenselogging-active").data("old") ||
                trimAll(entry.find(".txt-intenselogging-daysActive").val()) != entry.find(".txt-intenselogging-daysActive").data("old") ||
                trimAll(entry.find(".txt-intenselogging-daysBeforeDeleted").val()) != entry.find(".txt-intenselogging-daysBeforeDeleted").data("old")
                
               
            ) {
               
                extended.ZstCorrection.StartValue = trimAll(entry.find(".txt-setext-zst-startvalue").val().replace(",", "."));
                if (main.Status === 2) { oldExtended.ZstCorrection.StartValue = entry.find(".txt-setext-zst-startvalue").data("old").replace(",", "."); }
                extended.MeterReadings.MoveReadingTimestamp = trimAll(entry.find(".txt-setext-movereadingtimestamp").val());
                if (main.Status === 2) { oldExtended.MeterReadings.MoveReadingTimestamp = entry.find(".txt-setext-movereadingtimestamp").data("old"); }

                extended.GeoLocation.Lat = trimAll(entry.find(".txt-setext-geo-lat").val());
                if (main.Status === 2) { oldExtended.GeoLocation.Lat = entry.find(".txt-setext-geo-lat").data("old"); }
                extended.GeoLocation.Lon = trimAll(entry.find(".txt-setext-geo-lon").val());
                if (main.Status === 2) { oldExtended.GeoLocation.Lon = entry.find(".txt-setext-geo-lon").data("old"); }



                extended.Logging.Active = entry.find(".chb-intenselogging-active").prop("checked");
                if (main.Status === 2) { oldExtended.Logging.Active = entry.find(".chb-intenselogging-active").data("old"); }
                
                extended.Logging.DaysActive = trimAll(entry.find(".txt-intenselogging-daysActive").val());
                if (main.Status === 2) { oldExtended.Logging.DaysActive = entry.find(".txt-intenselogging-daysActive").data("old"); }
         
                extended.Logging.DaysBeforeDeleted = trimAll(entry.find(".txt-intenselogging-daysBeforeDeleted").val());
                if (main.Status === 2) { oldExtended.Logging.DaysBeforeDeleted = entry.find(".txt-intenselogging-daysBeforeDeleted").data("old"); }

               
              
                if (!extended.Logging.Active) {
                    if (extended.Logging.Active != oldExtended.Logging.Active) {
                        extended.Logging.DaysActive = 0;
                        extended.Logging.DaysBeforeDeleted = 0;
                        extended.Logging.DaysBeforeDeleted = 0;
                        extended.Logging.StartDate = "";
                       

                    }

                } else {
                    extended.Logging.StartDate = moment().format('DD.MM.YYYY');
                 
                }

                //console.info("save: " + main.Status);
                //console.info(extended.Logging);

                dirtyMain = true;

            } else {
                extended = null;
            }

            //if any file credential settings has changed we have to save everything
            if (

                trimAll(entry.find(".txt-filecredentials-test").val()) != entry.find(".txt-filecredentials-test").data("old")
            ) {

                fileCredentials.Test = trimAll(entry.find(".txt-filecredentials-test").val());
                if (main.Status === 2) { oldFileCredentials.Test = entry.find(".txt-filecredentials-test").data("old"); }

                dirtyMain = true;

            } else {
                fileCredentials = null;
            }

            //if any bacnet settings has changed we have to save everything
            if (

                trimAll(entry.find(".txt-bacnet-test").val()) != entry.find(".txt-bacnet-test").data("old")
            ) {

                bacnet.Test = trimAll(entry.find(".txt-bacnet-test").val());
                if (main.Status === 2) { oldBacnet.Test = entry.find(".txt-bacnet-test").data("old"); }

                dirtyMain = true;

            } else {
                bacnet = null;
            }
         


            
            //set bsaid and data status
            if (typeof (entry.data("infoid")) === "undefined") {
                info.Status = 1; // add new
            } else {
                info.Id = entry.data("infoid");
                info.Status = 2; // edit
            }
            dirtyInfo = false;
            if (parseInt(entry.find(".ddl-dims").val(), 10) !== parseInt(entry.find(".ddl-dims").data("old"), 10)) {
                info.Bdimsid = entry.find(".ddl-dims").val();
                if (info.Status === 2) { oldInfo.Bdimsid = entry.find(".ddl-dims").data("old"); }
                dirtyInfo = true;
            }
            if (entry.find(".txt-name").val() !== entry.find(".txt-name").data("old")) {
                info.name = entry.find(".txt-name").val();
                if (info.Status === 2) { oldInfo.name = entry.find(".txt-name").data("old"); }
                dirtyInfo = true;
            }
            if (entry.find(".a-desc").val() !== entry.find(".a-desc").data("old")) {
                info.Description = entry.find(".a-desc").val();
                if (info.Status === 2) { oldInfo.Description = entry.find(".a-desc").data("old"); }
                dirtyInfo = true;
            }
            if (parseInt(entry.find(".ddl-signal-group").val(), 10) !== parseInt(entry.find(".ddl-signal-group").data("old"), 10)) {
                info.Bsagid = entry.find(".ddl-signal-group").val();
                if (info.Status === 2) { oldInfo.Bsagid = entry.find(".ddl-signal-group").data("old"); }
                dirtyInfo = true;
            }


        
            //set bsaid and data status
            //if the bsahid does not exist or the signal was a signal rule then we add a new hardware
            if ((typeof (entry.data("bsahid")) === "undefined" || entry.data("bsahid") === null)) {
                hw.Status = 1; // add new
            } else {
                hw.Id = entry.data("bsahid");
                hw.Status = 2; // edit
            }
            if(isNaN( parseInt(entry.find(".ddl-hardware :selected").data("id"), 10))) {
                hw.Status = 3; //if the current hardware has no blhnid (so it must be a signal rule) we have to delete the old hardware from that entry 
                oldHw.Blhid = entry.find(".ddl-hardware").data("old");
                dirtyHw = true;
            }

           
            // hmmm ... ?
            dirtyHw = false;
            if (parseInt(entry.find(".ddl-hardware").val(), 10) !== parseInt(entry.find(".ddl-hardware").data("old"), 10)) {
                hw.Blhid = entry.find(".ddl-hardware").val();
                if (hw.Status === 2) { oldHw.Blhid = entry.find(".ddl-hardware").data("old"); }
                dirtyHw = true;
            }
            if (parseInt(entry.find(".ddl-meter").val(), 10) !== parseInt(entry.find(".ddl-meter").data("old"), 10)) {
                hw.Blhmid = entry.find(".ddl-meter").val();
                if (hw.Status === 2) { oldHw.Blhmid = entry.find(".ddl-meter").data("old"); }
                dirtyHw = true;
            }
            if (parseInt(entry.find(".txt-smooth").val(), 10) !== parseInt(entry.find(".txt-smooth").data("old"), 10)) {
                hw.Smooth = entry.find(".txt-smooth").val();
                if (hw.Status === 2) { oldHw.Smooth = entry.find(".txt-smooth").data("old"); }
                dirtyHw = true;
            }
            if (entry.find(".a-hw-desc").val() !== entry.find(".a-hw-desc").data("old")) {
                hw.Description = entry.find(".a-hw-desc").val();
                if (hw.Status === 2) { oldHw.Description = entry.find(".a-hw-desc").data("old"); }
                dirtyHw = true;
            }

            if (parseInt(entry.find(".txt-pic").val(), 10) !== parseInt(entry.find(".txt-pic").data("old"), 10)) {
                hw.MediaID = entry.find(".txt-pic").val();
                if (hw.Status === 2) { oldHw.MediaID = entry.find(".txt-pic").data("old"); }
                dirtyHw = true;
            }
            if (entry.find(".chb-validated").prop("checked") !== entry.find(".chb-validated").data("old")) {
                hw.Validated = entry.find(".chb-validated").prop("checked");
                if (hw.Status === 2) { oldHw.Validated = entry.find(".chb-validated").data("old"); }
                dirtyHw = true;
            }
            if (entry.find(".chb-measure").prop("checked") !== entry.find(".chb-measure").data("old")) {
                hw.Measure = entry.find(".chb-measure").prop("checked");
                if (hw.Status === 2) { oldHw.Measure = entry.find(".chb-measure").data("old"); }
                dirtyHw = true;
            }


            //let's find out what to add to the saving list
            if (dirtyMain) {
                signal.main = main;
                signal.main.OpcSettings = opcSettings;
                signal.main.Extended = extended;
                signal.main.FileCredentials = fileCredentials;
                signal.main.Bacnet = bacnet;
                if (main.Status === 2) { signal.oldMain = oldMain; signal.oldMain.OpcSettings = oldOpcSettings, signal.oldMain.Extended = oldExtended, signal.oldMain.FileCredentials = oldFileCredentials, signal.oldMain.Bacnet = oldBacnet}
            }

            if (dirtyInfo) {
                signal.info = info;
                if (info.Status === 2) {signal.oldInfo = oldInfo;}
            }

            if (dirtyHw) {
                signal.hardware = hw;
                if (hw.Status >1) {signal.oldHardware = oldHw;}
            }

            //if (dirtyOpc) {
            //    signal.opcSettings = opcSettings;
            //    if (opcSettings.Status > 1) { signal.oldOpcSettings = oldOpcSettings; }
            //}


            //addr
            signal.addresses = [];
            signal.oldAddresses = [];
            dirtyAddrArchive = false;
            dirtyAddrOnline = false;

            addrRet = {}
            //console.info(entry.find(".txt-name").val());
            //console.info(entry);
            
            if (entry.find(".addr").hasClass("ignore") === false) {
                
                //set addrid and data status
                if (typeof (entry.data("addrArchive")) === "undefined") {
                   
                    addrRet = me.saveAddress(entry, 1, 1, "archive");
                   
                    signal.addresses.push(addrRet.addr);
                    dirtyAddrArchive = true;
                } else {
                   
                    //add a new one
                    addrRet = me.saveAddress(entry, 1, 2, "archive");
                    if (addrRet.dirty) {
                        addrRet.addr.Id = entry.data("addrArchive");
                        signal.addresses.push(addrRet.addr);
                        signal.oldAddresses.push(addrRet.oldAddr);
                        dirtyAddrArchive = true;
                    }
                }

                //addr addr-online
                //set addrid and data status

                if (entry.find(".addr-online").hasClass("empty") === false) {
                   
                    if (typeof (entry.data("addrOnline")) === "undefined") {
                        addrRet = me.saveAddress(entry, 2, 1, "online");
                        if (addrRet.dirty) {
                            signal.addresses.push(addrRet.addr);
                            dirtyAddrOnline = true;
                        }
                        
                    } else {
                        //add a new one
                        addrRet = me.saveAddress(entry, 2, 2, "online");
                        if (addrRet.dirty) {
                            addrRet.addr.Id = entry.data("addrOnline");
                            signal.addresses.push(addrRet.addr);
                            signal.oldAddresses.push(addrRet.oldAddr);
                            dirtyAddrOnline = true;
                        }
                    }
                } else {
                    //if an archive entry id exists but it got deleted ... 
                    if (typeof (entry.data("addrOnline")) !== "undefined") {
                        signal.addresses.push({ "id": entry.data("addrOnline"), "status": 3 });
                        dirtyAddrOnline = true;
                    }
                }
            }
           
            if (dirtyMain || dirtyInfo || dirtyHw || dirtyAddrArchive || dirtyAddrOnline) {
                list.push(signal);
            }
        });


        if (list.length === 0) {me.finishSaving();return true}

      
        var param = list;


        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
        function (result) {
            if (result === null) { me.showMessage(me.resources.err_saveData, true); return true}
            if (result === false) { me.showMessage(me.resources.err_saveData, true);return true }
           
            me.finishSaving();
            return true;
        });

        return true;

    } catch (ex) {
        me.writeError('save', ex);return false;
    }

};

UnitAnalogEditor.prototype.saveAddress = function (entry, typeid, status, sClass) {
    /// <summary>
    /// This function generates the entries for the saving list for one single address type <br/>
    /// </summary>
    var me = this;
    var addr = {}, oldAddr = {};
    var ret = {}
    var dirty = false;
    try {
        if (me.error) { return false; }

        addr.AddrTypeID = typeid;

        oldAddr.AddrTypeID = typeid;
        addr.Status = status;

        if (status === 1) { dirty = true }
       
        if (status === 1) {
            addr.Bdimsid = parseInt(entry.find(".ddl-" + sClass + "-dims").val(), 10);
        } else {
            if (parseInt(entry.find(".ddl-" + sClass + "-dims").val(), 10) !== parseInt(entry.find(".ddl-" + sClass + "-dims").data("old"), 10)) {
                addr.Bdimsid = parseInt(entry.find(".ddl-" + sClass + "-dims").val(), 10);
                oldAddr.Bdimsid = entry.find(".ddl-" + sClass + "-dims").data("old");
                dirty = true;
            }
        }
        
        if (status === 1) {
            addr.Blhmtid = parseInt(entry.find(".ddl-" + sClass + "-meter-type").val(), 10);
        } else {
            if (parseInt(entry.find(".ddl-" + sClass + "-meter-type").val(), 10) !== parseInt(entry.find(".ddl-" + sClass + "-meter-type").data("old"), 10)) {
                addr.Blhmtid = parseInt(entry.find(".ddl-" + sClass + "-meter-type").val(), 10);
                oldAddr.Blhmtid = entry.find(".ddl-" + sClass + "-meter-type").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Blhmfid = parseInt(entry.find(".ddl-" + sClass + "-meter-format").val(), 10);
        } else {
            if (parseInt(entry.find(".ddl-" + sClass + "-meter-format").val(), 10) !== parseInt(entry.find(".ddl-" + sClass + "-meter-format").data("old"), 10)) {
                addr.Blhmfid = parseInt(entry.find(".ddl-" + sClass + "-meter-format").val(), 10);
                oldAddr.Blhmfid = entry.find(".ddl-" + sClass + "-meter-format").data("old");
                dirty = true;
            }
        }
        
        if (status === 1) {
            addr.Mkorr = parseFloat(entry.find(".txt-" + sClass + "-mkorr").val().replace(",", "."), 10);
        } else {
            if (entry.find(".txt-" + sClass + "-mkorr").val() !== entry.find(".txt-" + sClass + "-mkorr").data("old")) {
                addr.Mkorr = parseFloat(entry.find(".txt-" + sClass + "-mkorr").val().replace(",", "."), 10);
                oldAddr.Mkorr = entry.find(".txt-" + sClass + "-mkorr").data("old").replace(",", ".");
                dirty = true;
            }
        }
        
        if (status === 1) {
            addr.Skorr = parseFloat(entry.find(".txt-" + sClass + "-skorr").val().replace(",", "."), 10);
        } else {
            if (entry.find(".txt-" + sClass + "-skorr").val() !== entry.find(".txt-" + sClass + "-skorr").data("old")) {
                addr.Skorr = parseFloat(entry.find(".txt-" + sClass + "-skorr").val().replace(",", "."), 10);
                oldAddr.Skorr = entry.find(".txt-" + sClass + "-skorr").data("old").replace(",", ".");
                dirty = true;
            }
        }
        

        if (status === 1) {
            addr.Addr = parseInt(entry.find(".txt-" + sClass + "-addr").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-addr").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-addr").data("old"), 10)) {
                addr.Addr = parseInt(entry.find(".txt-" + sClass + "-addr").val(), 10);
                oldAddr.Addr = entry.find(".txt-" + sClass + "-addr").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Reg = parseInt(entry.find(".txt-" + sClass + "-reg").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-reg").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-reg").data("old"), 10)) {
                addr.Reg = parseInt(entry.find(".txt-" + sClass + "-reg").val(), 10);
                oldAddr.Reg = entry.find(".txt-" + sClass + "-reg").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Len = parseInt(entry.find(".txt-" + sClass + "-len").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-len").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-len").data("old"), 10)) {
                addr.Len = parseInt(entry.find(".txt-" + sClass + "-len").val(), 10);
                oldAddr.Len = entry.find(".txt-" + sClass + "-len").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Funcreg = parseInt(entry.find(".txt-" + sClass + "-funcreg").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-funcreg").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-funcreg").data("old"), 10)) {
                addr.Funcreg = parseInt(entry.find(".txt-" + sClass + "-funcreg").val(), 10);
                oldAddr.Funcreg = entry.find(".txt-" + sClass + "-funcreg").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.HighLow = parseInt(entry.find(".txt-" + sClass + "-highlow").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-highlow").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-highlow").data("old"), 10)) {
                addr.HighLow = parseInt(entry.find(".txt-" + sClass + "-highlow").val(), 10);
                oldAddr.HighLow = entry.find(".txt-" + sClass + "-highlow").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Interval = parseInt(entry.find(".txt-" + sClass + "-interval").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-interval").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-interval").data("old"), 10)) {
                addr.Interval = parseInt(entry.find(".txt-" + sClass + "-interval").val(), 10);
                oldAddr.Interval = entry.find(".txt-" + sClass + "-interval").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Minmes = parseInt(entry.find(".txt-" + sClass + "-hw-minmes").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-hw-minmes").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-hw-minmes").data("old"), 10)) {
                addr.Minmes = parseInt(entry.find(".txt-" + sClass + "-hw-minmes").val(), 10);
                oldAddr.Minmes = entry.find(".txt-" + sClass + "-hw-minmes").data("old");
                dirty = true;
            }
        }
        if (status === 1) {
            addr.Maxmes = parseInt(entry.find(".txt-" + sClass + "-hw-maxmes").val(), 10);
        } else {
            if (parseInt(entry.find(".txt-" + sClass + "-hw-maxmes").val(), 10) !== parseInt(entry.find(".txt-" + sClass + "-hw-maxmes").data("old"), 10)) {
                addr.Maxmes = parseInt(entry.find(".txt-" + sClass + "-hw-maxmes").val(), 10);
                oldAddr.Maxmes = entry.find(".txt-" + sClass + "-hw-maxmes").data("old");
                dirty = true;
            }
        }
        
        ret.addr = addr;
        ret.oldAddr = oldAddr;
        ret.dirty = dirty;

        return ret;
    } catch (ex) {
        me.writeError('saveAddress', ex); return null;
    }

};

UnitAnalogEditor.prototype.finishSaving = function () {
    /// <summary>
    /// This function finishes the saving process <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
       
       
        me.fetchEntries();
       
        me.showUnit(false);
        
        me.visual.find("#signal-table").html("");
        me.visual.find("#div-btn-save").removeClass("active").removeClass("saved").addClass("saved");
        me.visual.find("#div-menu #div-state").removeClass("error note clear").addClass("note");
        me.visual.find("#div-menu .state-info").hide();
        me.visual.find("#div-menu #div-saved").show();
     
        _VCMQ.produce(me.visual, me.vcgid, 'SIGNAL_ANALOG_DETAIL_CLOSE', '');
      
       
        me.fetchRuleCounter();
     

        return true;
    } catch (ex) {
        me.writeError('finishSaving', ex); return false;
    }

};


//validation
//**********

UnitAnalogEditor.prototype.validateImport = function (sClass) {
    /// <summary>
    /// This function iterates all entries (except dll and chb) gets the validation limits from the according template entry and validates the input field. 
    /// </summary>
    var me = this;
    var val, type, min, max, obj, template;
    try {
        if (me.error) { return false; }

        me.visual.find("#signal-table ." + sClass).removeClass("invalid");

        me.visual.find("#div-signal-template ." + sClass).each(function() {

            template = $(this);
            if (template.hasClass("ddl") === false && template.hasClass("chb") ===false ) {
             
                type = template.data("type");
                min = parseInt(template.data("min"), 10);
                max = parseInt(template.data("max"), 10);

                //generate a selector based on all classes of the object in the template entry ;-)
                obj = me.visual.find("#signal-table ." + template.attr('class').split(' ').join('.'));
                //type based validation


                if (obj.hasClass("ignore") === false) {
                    switch (type) {
                    case "text":
                        obj.filter(function() { return ($(this).val().length < min || $(this).val().length > max) })
                            .addClass("invalid");
                        break;
                        case "integer":

                          
                        obj.filter(function() {
                            return (validateInteger($(this).val()) === false) ||
                                ($(this).val().indexOf(",") > -1) ||
                                (($(this).val() < min || $(this).val() > max));
                        }).addClass("invalid");
                        break;

                        case "number":
                        obj.filter(function() {
                            val = $(this).val();
                            if (validateNumeric(val) === false) return true;

                            val = val.replace(",", ".");
                            if (val >= 0) {
                                val = Math.ceil(val);
                            } else {
                                val = Math.floor(val);
                            }
                            return (val < min || val > max);
                        }).addClass("invalid");
                        break;
                    default:
                    }
                }
            }
        });
    
     
        return true;
    } catch (ex) { me.writeError('validateImport', ex); return false }
};

UnitAnalogEditor.prototype.validate = function (obj) {
    /// <summary>
    /// This function validats one single entry.<br/>
    /// Optionally it validates if the ddl-dims and the ddl-archive-dims are the same!
    /// </summary>
    var me = this;
    var validateDims = false;
    try {
        if (me.error) { return false; }

        me.storeAdditionalFilterString(obj.parents("li"));
        //console.info(obj.parents("li"));
        //do nothing in the rule editor
        if (obj.parents(".rule-editor").length > 0) {return true;}
        //generate a selector based on all classes of the object in the template entry ;-)
        var template = me.visual.find("#div-signal-template ." + obj.clone().removeClass("new invalid dirty warn").attr('class').split(' ').join('.'));

        var val = trimAll(obj.val());
        var type = template.data("type");
        var min = parseInt(template.data("min"),10);
        var max = parseInt(template.data("max"), 10);

        var dims, dims1;
        if (obj.hasClass("ignore") === false) {
            if (obj.hasClass("ddl-archive-dims")) {
                dims = obj;
                dims1 = obj.parents("li").find(".ddl-dims");
                validateDims = true;
            }
            if (obj.hasClass("ddl-dims")) {
                dims = obj;
                dims1 = obj.parents("li").find(".ddl-archive-dims");
                if (dims1.hasClass("ignore") === false) {
                    validateDims = true;
                }
            }
        }

        if (validateDims) {
            if (dims.val() !== dims1.val()) {
                dims.removeClass("warn").addClass("warn");
                dims1.removeClass("warn").addClass("warn");
            } else {
                dims.parents("li").find(".warn").removeClass("warn");
            }
        }

        switch (type) {
            case "text":

                me.isValid(obj, (val.length >= min && val.length <= max)); break;
            case "integer":
                if (validateInteger(val) === false) { me.isValid(obj, false);return true;}
                if (val.indexOf(",") >-1) {me.isValid(obj, false); return true;}
                me.isValid(obj, (val >= min && val <= max));
                break;
            case "number":
                if (validateNumeric(val)=== false) { me.isValid(obj, false);return true;}

                val = val.replace(",", ".");
                if (val >= 0) {
                    val = Math.ceil(val);
                } else {
                    val = Math.floor(val);
                }
                me.isValid(obj, (val >= min && val <= max));
                break;

        default:
        }
        //validate opc client
        if (obj.hasClass("txt-opccl-namespace") || obj.hasClass("txt-opccl-nodeid")) {
            let opcclNamespace = obj.parents("li").find(".txt-opccl-namespace");
            let opcclNodeId = obj.parents("li").find(".txt-opccl-nodeid")
            opcclNamespace.removeClass("invalid");
            opcclNodeId.removeClass("invalid");

            if ((trimAll(opcclNamespace.val()) + trimAll(opcclNodeId.val())).length > 0) {
                me.isValid(opcclNamespace, trimAll(opcclNamespace.val()).length > 0);
                me.isValid(opcclNodeId, trimAll(opcclNodeId.val()).length > 0);
            }
        }
        ////validate opc server
        //if (obj.hasClass("chb-opcsrv-active") || obj.hasClass("txt-opcsrv-nodeid")) {
        //    let opcsrvNodeId = obj.parents("li").find(".txt-opcsrv-nodeid");
        //    if (obj.parents("li").find(".chb-opcsrv-active").prop("checked")) {
        //        me.isValid(opcsrvNodeId, trimAll(opcsrvNodeId.val()).length > 0);
        //    } else {
        //        me.isValid(opcsrvNodeId, true);
        //    }
        //}
        //validate opc write
        if (obj.hasClass("chb-opcwrite-active") || obj.hasClass("txt-opcwrite-nodeid") || obj.hasClass("txt-opcwrite-namespace") || obj.hasClass("txt-opcwrite-url")) {
            let opcwriteNodeId = obj.parents("li").find(".txt-opcwrite-nodeid");
            let opcwriteNamespace = obj.parents("li").find(".txt-opcwrite-namespace");
            let opcwriteUrl = obj.parents("li").find(".txt-opcwrite-url");
            if (obj.parents("li").find(".chb-opcwrite-active").prop("checked")) {
                me.isValid(opcwriteNodeId, trimAll(opcwriteNodeId.val()).length > 0);
                me.isValid(opcwriteNamespace, trimAll(opcwriteNamespace.val()).length > 0);
                me.isValid(opcwriteUrl, trimAll(opcwriteUrl.val()).length > 0);
            } else {
                me.isValid(opcwriteNodeId, true);
                me.isValid(opcwriteNamespace, true);
                me.isValid(opcwriteUrl, true);
            }
        }



        return true;
    } catch (ex) { me.writeError('validate', ex); return false }
};

UnitAnalogEditor.prototype.isValid = function (obj, valid) {
    /// <summary>
    /// This function sets the validation state of a single entry. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.showInfo("", "", false);
        if (valid) {
            obj.removeClass("invalid");
            obj.removeClass("dirty").addClass("dirty");
            obj.parents(".area").removeClass("dirty").addClass("dirty");
        } else {

            console.info(obj);

            obj.addClass("invalid");
        }
        me.countErrors();


        return true;
    } catch (ex) { me.writeError('isValid', ex); return false }
};

UnitAnalogEditor.prototype.countErrors = function () {
    /// <summary>
    /// This function counts all invalid entries and generates a error list next to the save button.
    /// It handles the enabling/disabling of the save button as well
    /// </summary>
    var me = this;
    var total;
    try {
        if (me.error) { return false; }
       
        total = me.visual.find("#signal-table .invalid").length;
        if (total > 0) {
            me.visual.find("#div-btn-save").removeClass("active");
            me.visual.find("#div-menu #div-state").removeClass("error note clear").addClass("error");
            me.visual.find("#div-menu .state-info").hide();
            me.visual.find("#div-menu #div-errors").show();
            me.visual.find("#div-menu #span-error-total").html(total);

            me.visual.find("#div-menu #span-error-main").html(me.visual.find("#signal-table .main .invalid, #signal-table .sub .invalid").length);
            me.visual.find("#div-menu #span-error-addr").html(me.visual.find("#signal-table .addr .invalid").length);
            me.visual.find("#div-menu #span-error-docu").html(me.visual.find("#signal-table .docu .invalid").length);
            me.visual.find("#div-menu #span-error-others").html(me.visual.find("#signal-table .others .invalid").length);

        } else {
            me.visual.find("#div-btn-save").removeClass("active").addClass("active");
            //if data got saved right now - we keep the saved info until the next data changing
            if (me.visual.find("#div-btn-save").hasClass("saved")) {
                me.visual.find("#div-menu #div-state").removeClass("error clear");
                me.visual.find("#div-btn-save").removeClass("saved");
            } else {
                me.visual.find("#div-menu #div-state").removeClass("error note clear").addClass("clear");
                me.visual.find("#div-menu .state-info").hide();
            }
           
        }
        return true;
    } catch (ex) { me.writeError('countErrors', ex); return false }
};


//entry events
//**********

UnitAnalogEditor.prototype.changeHardware = function (obj) {
    /// <summary>
    /// This function opens a dialog box when changing a hardware.   
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        var title;
        if (me.last_hw !== "-1") {
            if (obj.val() === "-1") {
                title = me.resources.shouldSignalGetARule;
            } else {
                title = me.resources.shouldSignalHardwareGetChanged;
            }
        } else {
            title = me.resources.shouldRuleGetSignal;
        }

        me.openAskDialog(title,{ my: 'top-200px', at: 'top', of: obj }, function () {
            me.adoptHardwareParameter(obj, false);
            me.countErrors();
        },
        function () { obj.val(me.last_hw); });

        return true;
    } catch (ex) { writeError('changeHardware', ex); return false }
};

UnitAnalogEditor.prototype.adoptHardwareParameter = function (obj, overwrite) {
    /// <summary>
    /// This function sets all specific hardware/address parameters for the selected hardware  <br/>
    /// It shows/hides address attributes and sets the specific header caption
    /// </summary>
    var me = this;
    var found = false;
    var settings;
    var blhnid;
    try {
        if (me.error) { return false; }

       //get the hardware name id from the ddl-hardware
        blhnid = parseInt(obj.find(":selected").data("id"), 10);
        settings = obj.parents("li").find(".addr .set");
        obj.parents("li").find(".btn-clone").show();

        //HARDCODED OPC SETTINGS
        if (blhnid == 69) {   // only for .OPC .net client in capture*/
            obj.parents("li").find(".addr .opc").css("display", "inline-block");
            obj.parents("li").find(".addr-online").hide();
            settings.hide();
        } else {
            obj.parents("li").find(".addr .opc").css("display", "none");
            obj.parents("li").find(".addr-online").show();
            settings.show();
        }




        //decide if it's a real hardware or a signal rule
        if ((isNaN(blhnid) === false) && parseInt(obj.val()) > 0) {
           
            //show/hide fields for signals/signal rules
           
            me.toggleRuleFields(obj, true);
            me.validate(obj);
            //remove the unused settings from the tab-index
            settings.removeClass("unused").addClass("unused").attr("tabindex", "-1");

            settings.filter(".l").val("-").prop("title", "");
            //iterate the hardware parameter list and set the accordings values
            for (var i = 0; i < me.hardwareParameterList.length; i++) {
                if (me.hardwareParameterList[i].blhnid === blhnid) {
                    found = true;
                    settings.filter("." + me.hardwareParameterList[i].formitem.replace("AnalogAddress", ""))
                        .removeClass("unused").removeAttr("tabindex");
                    settings.filter(".l." + me.hardwareParameterList[i].formitem.replace("AnalogAddress", ""))
                        .attr("tabindex", "-1");

                    if (overwrite) {
                        settings.filter("." + me.hardwareParameterList[i].formitem.replace("AnalogAddress", ""))
                            .val(me.hardwareParameterList[i].value);
                    }
                    settings.filter(".l." + me.hardwareParameterList[i].formitem.replace("AnalogAddress", ""))
                        .val(me.hardwareParameterList[i].name);
                }
                if (me.hardwareParameterList[i].blhnid !== blhnid && found) {
                    if (overwrite) {
                        settings.filter(".unused").val(0);
                    }
                    return true;
                }
            }
        } else {
          
          //  obj.parents("li").find(".btn-clone").hide();
            me.toggleRuleFields(obj, false);
           
            me.validate(obj);
         
        }





        me.filter();
        return true;
    } catch (ex) { me.writeError('adoptHardwareParameter', ex); return false }
};

UnitAnalogEditor.prototype.showOnlineAddr = function (obj, show) {
    /// <summary>
    /// This function shows/hides the online-address entries <br/>
    /// When it hides - it deletes all fld-attributes
    /// </summary>
    var me = this;
    var entry;
    var icon;
    try {
        if (me.error) { return false; }
        entry = obj.parents("li");
        if (show) {

            icon = obj.parent(".addr-online").find(".fa-clock").clone();
            obj.parent(".addr-online").find(".fa-clock").remove();
            obj.parent(".addr-online").prepend(me.visual.find("#div-signal-template .addr-online .fld").clone());
            obj.parent(".addr-online").prepend(icon);
            //we have to reset the hardware parameters for the online-addresses as well
            me.adoptHardwareParameter(entry.find(".ddl-hardware"), false);
            obj.parent(".addr-online").removeClass("empty");
            obj.siblings("input").show();
            obj.siblings(".ddl").show();
            obj.siblings(".btn-online-delete").show();
            obj.hide();

            //restore the original online data values
            if (typeof (obj.parents("li").data("addrOnline")) !== "undefined") {
                for (var i = 0; i < me.entries.length; i++) {
                    for (var j = 0; j < me.entries[i].Addresses.length; j++) {
                        if (me.entries[i].Addresses[j].Id === parseInt(entry.data("addrOnline"))) {
                            me.addAddress(entry, "online", me.entries[i].Addresses[j]);
                        }
                    }
                }
            }

        } else {
            obj.parent(".addr-online").removeClass("empty").addClass("empty");
            obj.parent(".addr-online").find(".fld").remove();
            obj.siblings(".btn-online-add").show();
            obj.hide();
        }

        me.isValid(entry, true);
        me.countErrors();

        return true;
    } catch (ex) {
        me.writeError('showOnlinAddr', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.toggleRuleFields = function (obj, bShow) {
    /// <summary>
    /// This function shows/hides fields which are not necessary for signal rules <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
       
        if (bShow) {
            //show all fields as we are a signal
            obj.parents("li").find(".addr").removeClass("ignore");
            obj.parents("li").find(".addr .fld").removeClass("ignore");
            obj.parents("li").find(".chb-validated,.ddl-hardware,.ddl-meter,.chb-measure,.a-hw-desc,.txt-smooth, .ddl-archive-dims").removeClass("ignore");
            obj.parents("li").find(".a-varname").removeClass("ignore");
            //clear the varname 
            if (obj.parents("li").find(".a-varname").val() === me.ruleVarname) {
                obj.parents("li").find(".a-varname").val("");
                obj.parents("li").find(".addr-online").removeClass("empty").addClass("empty");
            }
            //show the addresses again
            if (me.visual.find(".select-view.button-toggle-active").data("type") === "addr") {
                obj.parents("li").find(".addr").show();
            }

        } else {
            //hide all fields as we are a signal rule
            obj.parents("li").find(".a-varname").addClass("ignore");
            obj.parents("li").find(".addr").addClass("ignore").hide();
            obj.parents("li").find(".addr .fld").addClass("ignore");
            obj.parents("li").find(".addr-online").find(".fld").remove();
            //set the proper entry for the varname and zst
            obj.parents("li").find(".a-varname").val(me.ruleVarname);
            obj.parents("li").find(".ddl-zst").val(me.noZstID);
            obj.parents("li").find(".chb-validated,.ddl-hardware,.ddl-meter,.chb-measure,.a-hw-desc,.txt-smooth, .ddl-archive-dims").addClass("ignore");

        }
        me.validate(obj.parents("li").find(".ddl-dims"));
        return true;
    } catch (ex) {
        me.writeError('toggleRuleFields', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.setSpecificLegendTitle = function (obj) {
    /// <summary>
    /// This function searches the description of the selected address header and shows it as tooltip ;-)
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        var blhnid = parseInt(obj.parents("li").find(".ddl-hardware option:selected").data("id"), 10);
        for (var i = 0; i < me.hardwareParameterList.length; i++) {
            if (me.hardwareParameterList[i].blhnid === blhnid) {
                if (obj.hasClass(me.hardwareParameterList[i].formitem.replace("AnalogAddress", ""))) {
                    obj.prop("title", me.hardwareParameterList[i].description);
                    return true;
                }
            }
        }
        return true;
    } catch (ex) { me.writeError('setSpecificLegendTitle', ex); return false }
};

UnitAnalogEditor.prototype.showRules = function (bShow) {
    /// <summary>
    /// This function hides all entries which are no signal rules <br/>
    /// Then it iterates all rules and fills in the rule form for each entry.
    /// NOTE: the rule must get saved bevore the rule form can get shown
    /// </summary>
    var me = this;
    var bsaid;
    var w;
    try {
       
        if (me.error) { return false; }
        var list = me.visual.find("#signal-table li");

        //list.find(".rule").html("").hide();
        list.find(".rule").html("");
        if (bShow == false) { return true;}

        list.each(function () {
            var entry = $(this);
            var bsaid = parseInt(entry.find(".bsaid").html());
          
            var r = $("<div>").attr("id", "div-rule-" + bsaid);

            entry.find(".rules").html(r);
            r.SignalAnalogExtendedConfig({ invokeType: "addVisualBase", parameter: { bsaid: bsaid} })
        });
      
        return true;

    } catch (ex) {
        me.writeError('showRules', ex);
        return false;
    }

};


UnitAnalogEditor.prototype.showPics = function (bShow) {
    /// <summary>
    /// This function shows all signal pics for each entry. It inits the vcGallery for showing and editing medias.
    /// </summary>
    var me = this;
    var mediaid;
    try {
        if (me.error) { return false; }
        var list = me.visual.find("#signal-table li");

        if (bShow) {
            list.each(function() {
                mediaid = $(this).find(".txt-pic").val();

                if (typeof (mediaid) === "undefined") {
                    mediaid = "-1";
                }

                $(this).find(".txt-pic").attr("id", "mediaid" + parseInt(Math.random() * 100000, 10));
                $(this).find(".txt-pic").vcGallery({customerid: mediaid,mediaCategory: "SIGNAL",previewWidth: 50,previewHeight: 50, formItemWidth: 350, showDetails: true,onFileChanged: function() {me.countErrors();}
                });
            });
        } else {
           me.visual.find("#signal-table .vc-gallery").remove();
        }
       // me.filter();
        return true;
    } catch (ex) {
        me.writeError('showPics', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.loadImportList = function () {
    /// <summary>
    /// This function loads all signals from the hardware of the given import unit with the same hardware name.
    /// Theese signals can get imported now.
    /// </summary>
    var me = this;
    var lst = [];
    var item;
    try {
        if (me.error) { return false; }
       
        me.visual.find(".vc-list.import #vc-list-selection").html(me.vcC.getLoadingIcon());


        var param = { "type": 3, "blhid":parseInt( me.parameter.blhid,10), "importUnit": parseInt(me.visual.find(".ddl-import-unit").val(),10) }
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
        function (result) {

            if (result === null) { me.showMessage( me.resources.err_loadData, true); }
 
            if (result.rows === null) {
                me.visual.find(".vc-list.import #vc-list-selection").html("<div class='ui-corner-all ui-state-error' style='padding:5px;margin:3px:text-align:center'>" + me.resources.noEntriesExist + "</div>");
                return true;
            }
       
            for (var i = 0; i < result.rows.length; i++) {
              
                item = $("<li>").addClass("vc-list-item").data("id", result.rows[i].id).html(result.rows[i].name + ' [' + result.rows[i].dims + ']');
                lst.push(item);
            }
            me.visual.find(".vc-list.import #vc-list-selection").html(lst);
            me.visual.find(".vc-list.import .vc-list-item").removeClass("alt");
            me.visual.find(".vc-list.import #vc-list-selection .vc-list-item:even").addClass("alt");
            me.initImportHandler();
            return true;
        });

        return true;
} catch (ex) { writeError('loadImportList', ex); return false }
};

UnitAnalogEditor.prototype.initImportHandler = function () {
    /// <summary>
    /// This function inits the dbl click handler of the import signal list..   
    /// </summary>
    var me = this;
    var bsaid;
    try {
        if (me.error) { return false; }

       
        me.visual.find(".vc-list.import #vc-list-selection").off("dblclick", ".vc-list-item").on("dblclick", ".vc-list-item", function() {
            bsaid = $(this).data("id");
           
           
            var param = { "type": 1, "BsaidList": [bsaid] }
            window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
            function (result) {
                if (result === null) { me.showMessage(me.resources.err_loadData, true); }
                if (result.length === 0) { me.showInfo(me.resources.noEntriesExist, "", false); }
                ////add the entries
                _VCMQ.produce(me.visual, me.vcgid, 'IMPORT_ENTRY', result);
               
                return true;
            });


        });

        return true;
    } catch (ex) { writeError('initImportHandler', ex); return false }
};

UnitAnalogEditor.prototype.toggleImportList = function (obj, bShow, bReload) {
    /// <summary>
    /// This function shows/hides the import list and the according import button.   
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (bShow) {
            obj.find('span').text(me.resources.closeImport);
            obj.addClass("button-toggle-active");
            me.visual.find(".vc-list.import").show();
            me.visual.find("#signal-table").html("");
            me.countErrors();
            me.loadImportList();
        } else {
            obj.find('span').text(me.resources.openImport);
            obj.removeClass("button-toggle-active");
            me.visual.find(".vc-list.import").hide();
           if (bReload) {me.fetchEntries();}

         

        }

        return true;
    } catch (ex) { writeError('toggleImportList', ex); return false }
};

UnitAnalogEditor.prototype.showUnit = function (bReload) {
    /// <summary>
    /// This function fetches new entries, generates the entry list and validates it <br/>
    /// </summary>
    var me = this;
    var param;
    var bluid;
    try {
        if (me.error) { return false; }

        bluid = parseInt(me.visual.find("#div-unit-menu #ddl-unit-dest").val(), 10);

        if (isNaN(bluid)) {bluid = -1}


        // alert(bReload);
        if (bluid === -1) {
           if (bReload) { me.showAll();}
            return true;
        }

        param = { "type": 2, "UnitId": bluid }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
        function (result) {
            if (result === null) { me.showMessage(me.resources.err_loadData, true); }
            if (result.length === 0) { me.showInfo(me.resources.noEntriesExist, "", false); }

            me.visual.find("#div-unit-viewer #div-unit").html(result);
            me.visual.find('#div-unit-viewer #lstUnit li').tipTip({ defaultPosition: 'bottom' });
            me.setUnitViewerWidth();
           
            me.toggleImportList(me.visual.find("#div-btn-import"), false, false);

            if (bReload) {
                me.visual.find("#signal-table").html("");

              //  me.selectUnit(me.visual.find("#div-unit-menu #ddl-unit-dest"));
               // me.toggleWaiting(true, -1);
            } else {
                //reset the currently selected hardware
                if (me.parameter.blhid > 0) {
                    me.visual.find('#div-unit-viewer #lstUnit #hardware_' + me.parameter.blhid).addClass("active");
                }
            }
            me.selectUnit();
        
            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('showUnit', ex);
        return false;
    }

};

UnitAnalogEditor.prototype.setUnitViewerWidth = function () {
    /// <summary>
    /// This function resets the with for the unit viewer after each reloading <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find("#div-unit-viewer").width(me.width - parseInt(me.visual.find("#div-state").width(), 10) - parseInt(me.visual.find("#div-unit-menu").width(), 10) - 25);
        me.visual.find("#div-unit").width(parseInt(me.visual.find("#div-unit-viewer").width(), 10) - parseInt(me.visual.find(".div-unit-viewer-rules").width(), 10) - 25);
        return true;
    } catch (ex) {
        me.writeError('setUnitViewerWidth', ex);
        return false;
    }

};


UnitAnalogEditor.prototype.fetchRuleCounter = function () {
    /// <summary>
    /// This function fetches new entries, generates the entry list and validates it <br/>
    /// </summary>
    var me = this;
    var param;
    try {
        if (me.error) { return false; }

        param = { "type": 4 }

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify(param),
        function (result) {
            if (result === null) { me.showMessage(me.resources.err_loadData, true); }
            if (result.length === 0) { me.showInfo(me.resources.noEntriesExist, "", false); }
           
            me.visual.find(".div-rule-counter").html(result);
            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('fetchRuleCounter', ex);
        return false;
    }

};



//common/mixed 
//************


UnitAnalogEditor.prototype.initHeartbeat = function () {
    /// <summary>
    /// Sends an pseudo-request to the server - only to keep the user alive.
    /// </summary>
    var me = this;
    try {
      
     
        setInterval(function () {
            if (me.error) { return false; }
           
            window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify(me.parameter), '', 1, 2, JSON.stringify({ "type": -1, "Blhid": -1 }),
            function () {
                return true;
            });
           return true;

        }, 180000);


        return true;
    } catch (ex) { writeError('initHeartbeat', ex); return false; }
};

UnitAnalogEditor.prototype.adoptListHeight = function () {
        /// <summary>
        /// This function resets the current height of the signal list. 
        /// </summary>
    var me = this;
    var h;
       try {

           //adopt the height
        h = parseInt(me.height -parseInt(me.visual.find("#div-menu").height())
            -parseInt(me.visual.find(".vc-list.signals .vc-list-header").height())
            -parseInt(me.visual.find("#div-btn-add").height()) -75,10);

        if (me.visual.find("#div-signal-menu").is(":visible")) {
            h -= parseInt(me.visual.find("#div-signal-menu").height());
        }
        me.visual.find("#signal-table").height(h);


            } catch (ex) {me.writeError('adoptListHeight', ex);
       }
};

UnitAnalogEditor.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles different mq events. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }



        switch (event.msg) {
            case 'SHOW_PICS':
                setTimeout(function () { me.showPics(event.values); }, 100);
                break;
            //case 'SHOW_RULES':
            //    setTimeout(function() { me.showRules(event.values); }, 100);
            //    break;
            case 'RELOAD_ANALOGEDITOR':
                me.selectUnit();
                break;
            case 'ADD_ENTRIES':
                if (me.toggleWaiting(true, 1)) {setTimeout(function () { me.add(event.values, false); }, 0);}
                break;
            case 'IMPORT_ENTRY':
                me.add(event.values, true); 
                break;
            case 'FINISH_ADDING':

                if (me.vcgid != event.vcgid) break;
             



                if (me.toggleWaiting(true, 2)) {
                    setTimeout(function () {
                        me.validateImport("fld");
                      
                        me.visual.find("#div-btn-save").removeClass("active");
                        //if we imported new signals 
                        if (event.values) {
                            me.visual.find("#div-btn-save").addClass("active");
                            me.countErrors();
                        }
                        me.visual.find("#signal-table .entry .l").attr("tabindex", "-1");
                        me.visual.find("#signal-table").show();
                        me.toggleWaiting(false, 0);

                       
                        me.filter(true);
                       
                        //console.info("go");
                        me.showRules(me.visual.find(".select-view.button-toggle-active").data("type") === "rules");
                        //me.showPics(me.visual.find(".select-view.button-toggle-active").data("type") === "pic");

                       // console.info("no");
                    }, 0);
                }
                break;
            case 'STOP_WAITING': me.toggleWaiting(false, 0); break;
            default: break;
        }
        return true;
    } catch (ex) { writeError('doEvent', ex); return false}
};

UnitAnalogEditor.prototype.toggleWaiting = function (bShow, type) {
    /// <summary>
    /// This function shows/hides the waiting modal with different info text types <br/>
    /// </summary>
    var me = this;
    try {
       
        if (bShow) {
            switch (type) {
                case -1: //init 

                    me.visual.find("#modal-waiting-text").show(0).html(me.resources.makeSelection); break;
                case 0: //loading'
                    me.visual.find("#modal-waiting-text").show(0).html(me.vcC.getLoadingIcon()); break;
                case 1://generating
                    me.visual.find("#modal-waiting-text").show(0).html("<img src='../../images/visualcore/loading.gif' style='height:15px' /> " + me.resources.generatesEntries + ' ...'); break;
                case 2://validation
                    me.visual.find("#modal-waiting-text").show(0).html("<img src='../../images/visualcore/loading.gif' style='height:15px' /> " + me.resources.validatesData + ' ...'); break;
                case 3://no entries
                    me.visual.find("#modal-waiting-text").show(0).html(me.resources.noEntriesExist); break;
                default:
            } 
        } else {
            me.visual.find("#modal-waiting-text").hide(0).html("");
        }
        return true;
    } catch (ex) {
        me.writeError('toggleWaiting', ex);return false;
    }

};

UnitAnalogEditor.prototype.filter = function (bForce) {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
   
    var sTmp;
    try {
        if (me.error) { return false; }

        //we filter the optional tags we got from the vc-tags
        sTmp = me.visual.find(".vc-filter").vcFilter("getFilter");

        if (sTmp !== me.lastFilterString || bForce) {
            me.lastFilterString = sTmp;
        } else {
          return true;
        }
       
        ////hide all
        var list = me.visual.find("#signal-table li");

        list.removeClass("found show").data("counter", 0).css("display", "none");
       
        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", "#signal-table li", "found");

        list = list.filter(function () { return $(this).hasClass("hide") === false && $(this).hasClass("found")  });

        list.css("display", "block");
       // list.show();

        list.removeClass("alt");
        list.filter(":even").addClass("alt");

         setTimeout(function() {
             list.find(".right").css("display", "block");
         }, 50);
      
        return true;
    } catch (ex) {
        me.writeError('filter', ex);return false;
    }

};





UnitAnalogEditor.prototype.storeAdditionalFilterString = function (obj) {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    var sFilter;
    try {
        if (me.error) { return false; }


            sFilter = "bsaid" +
                obj.data("bsaid") +
                ";" +
                obj.find(".fld.txt-name").val() +
                ';' +
                obj.find(".fld.ddl-dims option:selected").text() +
                ';' +
                obj.find(".fld.ddl-signal-group option:selected").text() +
                ';' +
                obj.find(".fld.ddl-signal-type option:selected").text() +
                ';' +
                obj.find(".fld.ddl-hardware option:selected").text() +
                ';' +
                obj.find(".fld.ddl-meter option:selected").text() +
                ';' +
                obj.find(".fld.ddl-zst option:selected").text() +
                ';' +
                obj.find(".fld.a-desc").val() +
                ';' +
                obj.find(".fld.a-hw-desc").val() +
                ';' +
                obj.find(".fld.a-varname").val() +
                ';';

                sFilter += obj.find(".fld.ddl-archive-meter-format option:selected").text() +
                     ';mkorr' +
                    obj.find(".fld.txt-archive-mkorr").val() +
                    ';addr' +
                    obj.find(".fld.txt-archive-addr").val() +
                    ';reg' +
                    obj.find(".fld.txt-archive-reg").val() +
                      ';len' +
                    obj.find(".fld.txt-archive-len").val() +
                     ';highlow' +
                    obj.find(".fld.txt-archive-highlow").val() +
                      ';funcreg' +
                    obj.find(".fld.txt-archive-funcreg").val() +
                ';interval' +
                       obj.find(".fld.txt-archive-interval").val();

                if (obj.find(".addr-online").hasClass("empty") === false) {
                    //sFilter +='addr' + obj.find(".fld.txt-online-addr").val() +
                    //    ';reg' + obj.find(".fld.txt-online-reg").val();
                   sFilter +=  ';mkorr' +
                 obj.find(".fld.txt-online-mkorr").val() +
                 ';addr' +
                 obj.find(".fld.txt-online-addr").val() +
                 ';reg' +
                 obj.find(".fld.txt-online-reg").val() +
                   ';len' +
                 obj.find(".fld.txt-aonline-len").val() +
                  ';highlow' +
                 obj.find(".fld.txt-online-highlow").val() +
                   ';funcreg' +
                 obj.find(".fld.txt-online-funcreg").val() +
             ';interval' +
                    obj.find(".fld.txt-online-interval").val();
                }
                if (obj.find(".fld.chb-validated").prop("checked")) {
                    sFilter += ";valid";
                } else {

                    if (obj.find(".fld.chb-validated").hasClass("ignore")===false) { sFilter += ";invalid";}
                }
                obj.find(".filter").html(sFilter);

              

        return true;
    } catch (ex) {
        me.writeError('storeAdditionalFilterString', ex); return false;
    }

};

UnitAnalogEditor.prototype.setTagFilter = function (filterObj, listItem, classFound) {
    /// <summary>
    /// This function takes all tags from the vcFilter widget (filterObj) and adds a 'classFound' css class to all entries it founds in 'listItem'.<br/>
    /// It is used as part of the filter function in vc-lists
    /// </summary>
    var me = this;
    try {


        if (me.visual.find(filterObj + " .floatbox").length > 0) {
            //we reset the counter for found entries
            me.visual.find(listItem).data('counter', 0);

            //we filter the optional tags we got from the vc-tags
            var filter = me.visual.find(filterObj).vcFilter("getFilter");

            if (filter !== null) {
                var counter;
                //first, we count how often we find the filter tags in every signal item
                for (var i = 0; i <= filter.length - 1; i++) {
                    if (filter[i].length > 0) {
                        me.visual.find(listItem + " .filter:contains('" + filter[i] + "')")
                            .each(function () {
                                counter = parseInt($(this).parents("li").data('counter'), 10);
                                if (isNaN(counter)) {
                                    counter = 0;
                                }
                                counter++;
                                $(this).parents("li").data('counter', counter);
                            });
                    }
                }
                //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
                //why? if we have several filter tags we have to find all of them in one single signal 
                me.visual.find(listItem)
                    .each(function () {
                        if (parseInt($(this).data("counter"), 10) === filter.length) {
                            $(this).addClass(classFound);
                        }
                    });
            } else {
                me.visual.find(listItem).addClass(classFound);
            }
        }
    } catch (ex) {
        writeError(me.source + '.JS.setTagFilter', ex);
    }
};

UnitAnalogEditor.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
      
        me.toggleWaiting(false, 0);
        if (bError) {me.visual.find(".vc-list, #div-state, #div-btn-refresh,#div-btn-add, .select-view, #div-unit-viewer, #div-btn-import").hide();}
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


UnitAnalogEditor.prototype.writeError = function (source, ex) {
    var me = this;
    try {
       
        console.info(source + ':' + ex);
        me.error = true;
        me.showMessage(me.resources.err_code, true);
        writeError(me.source + ".JS." + source, ex);
        return false;
    } catch (ex) {
        me.error = true;
        writeError(me.source + '.JS.writeError', ex);
        return false;
    }
};